import React from 'react';
import { Form, Icon, Message, Button, Modal, Header, Divider } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import _find from 'lodash/find';
// import JsBarcode from 'jsbarcode';
import _ from 'lodash';

import ImprFact from '../../components/funcionales/imprfact'

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import EstaSeguro from '../../components/funcionales/estaseguro'
import EstaSegGral from '../../components/funcionales/estaseggral'

//utils
import queries from '../../utils/queries'

import codBarras from '../../../src/functions/codbarras'

import ListaServTar from '../../components/deestado/listaservtar'
import ImprRC from '../../components/funcionales/imprrc';
import general from '../../modulos/general';

// import Mapa from '../../../src/components/deestado/mapa';

const ListaInfAdic = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="infAdic1" id="miListaInfAdic" value={permiteUpdate?argsDocum.infAdic1:idLista.infAdic1} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>CONECTIC</option>
        <option>CABLE CAUCA - MORACERO</option>
      </select>
    </div>
  )
};

//dropdown CONCEPTOS
const DetalleSelCpto = props => {
  return (
    <option dato1={props.elemento.porcImpto?props.elemento.porcImpto:""} dato2={props.elemento.descrClaseServ} dato3={props.elemento.codigoImpto?props.elemento.codigoImpto:""} value={props.elemento.descrImpto?props.elemento.descrImpto:""}>{props.elemento.descrOtrosPagCl}</option>
  )
};

const ListaCpto = ({styles, handleCpto, list}) => {
  let detalleCpto = list.map((elemento, _id) => <DetalleSelCpto elemento={elemento} key={elemento._id}/>);
  return(
    <div>
      <select style={styles.input}className="ui simple selection dropdown fluid" name="cpto" id="miListaCpto" onChange={(ev) => handleCpto(ev)}>
        <option value="">Seleccionar...</option>
        {detalleCpto}
      </select>
    </div>
  )
};
//Fin dropdown CONCEPTOS

//dropdown SERVICIOS A PROGRAMAR
const DetalleSelSP = props => {
  let valorServicios = Number(props.elemento.rango1Valor)
  let valorI = 0
  if(props.elemento.imptos.length>0){
    for(let iiii=0; iiii<props.elemento.imptos.length; iiii++){
      let elemento1 = props.elemento.imptos[iiii]
      if(elemento1.codigoImpto){
        valorI += Math.round(valorServicios * (elemento1.porcImpto / 100))
      }
    }
    valorServicios = (Math.round((valorServicios + valorI) / 10) * 10) - valorI
    valorServicios += valorI
  }

  return (
    <option dato1={props.elemento.nombreResumido} dato2={props.elemento.descripcionServicio} dato3={valorServicios} value={props.elemento.codigoServicio}>{props.elemento.codigoServicio + " => " + props.elemento.nombreResumido + " => " + props.elemento.descripcionServicio + " => " + valorServicios}</option>
  )
};

const ListaServPS = ({styles, handleServProg, list}) => {
  let detalleSP = list.map((elemento, _id) => <DetalleSelSP elemento={elemento} key={elemento.codigoServicio}/>);
  return(
    <div>
      <select style={styles.input}className="ui simple selection dropdown fluid" name="servps" id="miListaSP" onChange={(ev) => handleServProg(ev)}>
        <option value="">Seleccionar...</option>
        {detalleSP}
      </select>
    </div>
  )
};
//Fin dropdown SERVICIOS A PROGRAMAR

//dropdown Años
const DetalleSelAgno = props => {
  return (
    <option>{props.elemento.agno}</option>
  )
};

const ListaAgno = ({styles, handleAgno, list}) => {
  let detalleAgno = list.map((elemento, _id) => <DetalleSelAgno elemento={elemento} key={elemento._id}/>);
  return(
    <div>
      <select style={styles.input}className="ui simple selection dropdown fluid" name="agno" id="miListaAgno" onChange={(ev) => handleAgno(ev)}>
        <option value="">Seleccionar...</option>
        {detalleAgno}
      </select>
    </div>
  )
};
//Fin dropdown Años
//dropdown Mes
const DetalleSelMes = props => {
  return (
    <option>{props.elemento.mes}</option>
  )
};

const ListaMes = ({styles, handleMes, list}) => {
  let detalleMes = list.map((elemento, _id) => <DetalleSelMes elemento={elemento} key={elemento._id}/>);
  return(
    <div>
      <select style={styles.input}className="ui simple selection dropdown fluid" name="mes" id="miListaMes" onChange={(ev) => handleMes(ev)}>
        <option value="">Seleccionar...</option>
        {detalleMes}
      </select>
    </div>
  )
};
//Fin dropdown Mes

//Lista servicios oferta
const ServiciosOf = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''></td>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className='center aligned'>{elemento.porcDctoOferta}</td>
      <td className='center aligned'>{elemento.numDiasOferta}</td>
      <td className=''>{elemento.fechaFinOferta}</td>
    </tr>
  )
};

const ListaServOf = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <ServiciosOf elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Lista de equipos
const EquiposCli = ({list, elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.numeroSerie}</td>
      <td className=''>{elemento.mac}</td>
      <td className=''>{elemento.descrClaseEqu}</td>
      <td className=''>{elemento.descrMarcaEqu}</td>
      <td className=''>{elemento.descrFabriEqu}</td>
    </tr>
  )
};

const ListaEquiCli = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <EquiposCli list={list} elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Lista de Movim CC
const MovimCCCli = ({list, elemento}) => {
  return(
    <tr className=''>
      <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.fechaMov.substr(0, 10)}</td>
      <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.descripcionServicio}</td>
      <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.periodo}</td>
      <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.origen}</td>
      <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{general.formatNum(elemento.valorTotal.toString())}</td>
      <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.documento}</td>
      <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.fechaNoFact?elemento.fechaNoFact.substr(0, 10):""}</td>
      <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.usuarioNoFact?elemento.usuarioNoFact:""}</td>
      <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.usuarioCreate?elemento.usuarioCreate:""}</td>
    </tr>
  )
};

const ListaMovCCCli = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <MovimCCCli list={list} elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Historia del cliente
const HistCli = ({list, elemento}) => {
  // console.log(elemento)
  return(
    <tr className=''>
      <td className=''>{elemento.fechaHistCliente.substr(0,10)}</td>
      <td className=''>{elemento.movimiento}</td>
      <td className='center aligned'>{elemento.numeroRT?elemento.numeroRT:elemento.relacion}</td>
      <td className=''>{elemento.descripcion}</td>
      <td className=''>{elemento.detalle}</td>
      <td className='center aligned'>{elemento.valor}</td>
      <td className=''>{elemento.usuarioCreate}</td>
    </tr>
  )
};

const ListaHistCli = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <HistCli list={list} elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Historia financiera
const HistFinancCli = ({elemento}) => {
  let fechaM = elemento.fechaMov.substr(0,10)
  return(
    <tr className=''>
      <td className='' style={{background: elemento.tipo==="C"?'#9D081C': ''}}>{fechaM}</td>
      <td className='' style={{background: elemento.tipo==="C"?'#9D081C': ''}}>{elemento.descripcionServicio!=="Ajuste"?elemento.descripcionServicio:elemento.nombreResumido}</td>
      <td className='' style={{background: elemento.tipo==="C"?'#9D081C': '', color: elemento.documento==="ANULADO"?'yellow':'#FAFFD1', fontWeight: 'bold'}}>{elemento.origen}</td>
      <td className='' style={{background: elemento.tipo==="C"?'#9D081C': ''}}>{elemento.periodo}</td>
      <td className='' style={{background: elemento.tipo==="C"?'#9D081C': '', color: elemento.documento==="ANULADO"?'yellow':'#FAFFD1', fontWeight: 'bold'}}>{elemento.documento!=="ANULADO"?elemento.documento:elemento.numeroRC}</td>
      {/* <td className='right aligned'>{general.formatNum(elemento.valorPagado.toString())}</td> */}
      <td className='right aligned' style={{background: elemento.tipo==="C"?'#9D081C': ''}}>{general.formatNum((elemento.valorTotal - elemento.valorPagado).toString())}</td>
      <td className='right aligned' style={{background: elemento.tipo==="C"?'#9D081C': '', color: elemento.valorTotal<0?'yellow':'#FAFFD1', fontWeight: 'bold'}}>{elemento.tipo==="C"?general.formatNum(elemento.valorTotal.toString()):0}</td>
      <td className='right aligned' style={{background: elemento.tipo==="C"?'#9D081C': '', color: elemento.valorTotal<0?'yellow':'#FAFFD1', fontWeight: 'bold'}}>{elemento.tipo!=="C"?general.formatNum(elemento.valorTotal.toString()):0}</td>
      <td className='right aligned' style={{background: elemento.tipo==="C"?'#9D081C': '', color: elemento.saldoCliente<0?'yellow':'#FAFFD1', fontWeight: 'bold'}}>{general.formatNum(elemento.saldoCliente.toString())}</td>
    </tr>
  )
};

const ListaHistFinanc = ({list}) => {
  // console.log(list)
  const nivel1Detalle = list.map((elemento, _id) => <HistFinancCli elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Lista de pagos
const PagosCli = ({elemento, idPago, handleClickidListaP, movimientos, idListaP, styles, fechaHoy}) => {
  // console.log(elemento._id, elemento.numeroRC)
  // console.log(elemento._id, idListaP._id)
  return(
    <tr className=''  onClick={(ev)=>handleClickidListaP(ev, elemento, idPago, movimientos, fechaHoy)}>
      <td className='' style={elemento._id===idListaP._id?styles.styTableSel:styles}>
        {elemento.fechaPago}</td>
      <td className='' style={elemento._id===idListaP._id?styles.styTableSel:elemento.documento==="ANULADO"?{color: 'yellow'}:styles}>
        {elemento.descripcionPago}</td>
      <td className='' style={elemento._id===idListaP._id?styles.styTableSel:styles}>
        {elemento.numeroRC?elemento.numeroRC:elemento.numeroFra}</td>
      <td className='right aligned' style={elemento._id===idListaP._id?styles.styTableSel:styles}>
        {elemento.valorEf?general.formatNum(elemento.valorEf.toString()):0}</td>
      <td className='right aligned' style={elemento._id===idListaP._id?styles.styTableSel:styles}>
        {elemento.valorCh?general.formatNum(elemento.valorCh.toString()):0}</td>
      <td className='right aligned' style={elemento._id===idListaP._id?styles.styTableSel:styles}>
        {elemento.valorTC?general.formatNum(elemento.valorTC.toString()):0}</td>
      <td className='right aligned' style={elemento._id===idListaP._id?styles.styTableSel:styles}>
        {elemento.valorTD?general.formatNum(elemento.valorTD.toString()):0}</td>
      <td className='right aligned' style={elemento._id===idListaP._id?styles.styTableSel:styles}>
        {elemento.valorTr?general.formatNum(elemento.valorTr.toString()):0}</td>
      <td className='right aligned' style={elemento._id===idListaP._id?styles.styTableSel:styles}>
        {elemento.valorTotal?general.formatNum(elemento.valorTotal.toString()):0}</td>
    </tr>
  )
};

const ListaPago = ({list, idPago, handleClickidListaP, movimientos, idListaP, styles, fechaHoy}) => {
  const nivel1Detalle = list.map((elemento, _id) => <PagosCli handleClickidListaP={handleClickidListaP}
        elemento={elemento} idPago={idPago} key={elemento._id} movimientos={movimientos} idListaP={idListaP}
        styles={styles} fechaHoy={fechaHoy}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Detalle del pago
const PagosCliDet = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className=''>{elemento.periodo}</td>
      <td className='right aligned'>{general.formatNum(elemento.valorDetalle.toString())}</td>
    </tr>
  )
};

const ListaPagoDet = ({list}) => {
  // console.log(list)
  const nivel1Detalle = list.map((elemento, _id) => <PagosCliDet elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Lista de facturas
const FactCli = ({elemento, handleClickidListaF, idListaF, styles}) => {
  // console.log(idListaF)
  return(
    <tr className=''  onClick={(ev)=>handleClickidListaF(ev, elemento)}>
      <td className='' style={elemento.numeroFra===idListaF.numeroFra?styles.styTableSel:styles}>
        {elemento.numeroFra}</td>
      <td className='' style={elemento.numeroFra===idListaF.numeroFra?styles.styTableSel:styles}>
        {elemento.fechaFact}</td>
      <td className='' style={elemento.numeroFra===idListaF.numeroFra?styles.styTableSel:styles}>
        {elemento.agno}</td>
      <td className='' style={elemento.numeroFra===idListaF.numeroFra?styles.styTableSel:styles}>
        {elemento.mes}</td>
      <td className='right aligned' style={elemento.numeroFra===idListaF.numeroFra?styles.styTableSel:styles}>
        {general.formatNum(elemento.valorAntesImptos.toString())}</td>
      <td className='right aligned' style={elemento.numeroFra===idListaF.numeroFra?styles.styTableSel:styles}>
        {general.formatNum(elemento.valorFacturado.toString())}</td>
      <td className='right aligned' style={elemento.numeroFra===idListaF.numeroFra?styles.styTableSel:styles}>
        {general.formatNum(elemento.valorFactura.toString())}</td>
    </tr>
  )
};

const ListaFact = ({list, handleClickidListaF, idListaF, styles}) => {
  const nivel1Detalle = list.map((elemento, _id) => <FactCli handleClickidListaF={handleClickidListaF}
    elemento={elemento} key={elemento._id} idListaF={idListaF} styles={styles}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Detalle de la factura
const FactCliDet = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className=''>{elemento.concepto}</td>
      <td className='right aligned'>{general.formatNum(elemento.valor.toString())}</td>
    </tr>
  )
};

const ListaFactDet = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <FactCliDet elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Lista de notas debito/credito
const NotCli = ({elemento, handleClickidListaNot}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidListaNot(ev, elemento)}>
      <td className=''>{elemento.numeroNota}</td>
      <td className=''>{elemento.tipoNota}</td>
      <td className=''>{elemento.fechaNota}</td>
      <td className=''>{elemento.numeroFra}</td>
      <td className=''>{elemento.usuarioCreate}</td>
      <td className='right aligned'>{general.formatNum(elemento.valorAntesImptos.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.valorNota.toString())}</td>
    </tr>
  )
};

const ListaNot = ({list, handleClickidListaNot}) => {
  const nivel1Detalle = list.map((elemento, _id) => <NotCli handleClickidListaNot={handleClickidListaNot} elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Detalle de la nota
const NotCliDet = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className=''>{elemento.concepto}</td>
      <td className='right aligned'>{general.formatNum(elemento.valor.toString())}</td>
    </tr>
  )
};

const ListaNotDet = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <NotCliDet elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Lista de ajustes positivos/negativos
const AjCli = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.numeroAjuste}</td>
      <td className=''>{elemento.tipoAjuste}</td>
      <td className=''>{elemento.fechaAjuste}</td>
      <td className=''>{elemento.usuarioCreate}</td>
      <td className=''>{elemento.concepto}</td>
      <td className='right aligned'>{general.formatNum(elemento.valorAjuste.toString())}</td>
    </tr>
  )
};

const ListaAj = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <AjCli elemento={elemento} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Detalle factura
const DetFactN = ({styles, elemento, handleChangeDetFN}) => {
  const rango1Ini = (valor) => {
    if(valor!==null){
      return valor
    }else{
      return ''
    }
  }
  return(
    <tr className=''>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className='right aligned'>{general.formatNum(elemento.valorSF.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.valorIF.toString())}</td>
      <td className='right aligned' style={styles.styPaddMarg}>
        <input type='number' step="1" min="0" style={styles.styInput} autoComplete="off" name="nuevoValor" id={elemento._id} value={rango1Ini(elemento.nuevoValor)} placeholder='Valor' onChange={(ev)=>handleChangeDetFN(ev, elemento)}/>
      </td>
    </tr>
  )
};

const ListaFactDetN = ({styles, list, handleChangeDetFN}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetFactN styles={styles} elemento={elemento} handleChangeDetFN={handleChangeDetFN} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//Detalle Mes No Facturar
const DetMNF = ({elemento, handleElimMNF, permiteMNF}) => {
  if(permiteMNF){
    return(
      <tr className=''>
        <td className=''>{elemento.agno}</td>
        <td className=''>{elemento.mes}</td>
        <td className=''>{elemento.observaciones}</td>
        <td className=''>{elemento.procesado}</td>
        <td className=''>{elemento.fechaCreate.substr(0, 10)}</td>
        <td className=''>{elemento.usuarioCreate}</td>
    
        <td className='center aligned'>
          <button className="ui button" style={{background: 'linear-gradient(#2c3e50, #bdc3c7, #bdc3c7 10%, #bdc3c7 10%, #bdc3c7 10%, #2c3e50)',
              color: '#89253e'}} onClick={(ev)=>handleElimMNF(ev, elemento)}>
            Eliminar
          </button>
        </td>
      </tr>
    )
  }else{
    return(
      <tr className=''>
        <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.agno}</td>
        <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.mes}</td>
        <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.observaciones}</td>
        <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.procesado}</td>
        <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.fechaCreate.substr(0, 10)}</td>
        <td className='' style={{background: elemento.procesado==="N"?'#9D081C': ''}}>{elemento.usuarioCreate}</td>
      </tr>
    )
    }
};

const ListaMNF = ({list, handleElimMNF, permiteMNF}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetMNF elemento={elemento}
    key={elemento._id} handleElimMNF={handleElimMNF} permiteMNF={permiteMNF}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const DetalleNivelCF = props => {
  return (
    <option value={props.elemento.cicloFact}>{props.elemento.cicloFact}</option>
  )
};

const ListaCF = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const NivelDetalleES = list.map((elemento, _id) => <DetalleNivelCF styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" value={permiteUpdate?argsDocum.cicloFact:idLista.cicloFact} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {NivelDetalleES}
      </select>
    </div>
  )
};

const DetalleNivelES = props => {
  return (
    <option value={props.elemento.descrEstrato}>{props.elemento.descrEstrato}</option>
  )
};
  
  const ListaES = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
      const NivelDetalleES = list.map((elemento, _id) => <DetalleNivelES styles={styles} elemento={elemento} key={elemento._id} />);
      return(
          <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEstrato" id="miLista3Estr" value={permiteUpdate?argsDocum.descrEstrato:idLista.descrEstrato} onChange={(ev)=>handleChange(ev, argsDocum)}>
              {NivelDetalleES}
            </select>
          </div>
      )
  };

  const DetalleNivelSeg = props => {
    return (
      <option value={props.elemento.codigoSegmento}>{props.elemento.descrSegmento}</option>
    )
  };
    
    const ListaSeg = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
// console.log(argsDocum.codigoSegmento, idLista.codigoSegmento)
      const NivelDetalleES = list.map((elemento, _id) => <DetalleNivelSeg styles={styles} elemento={elemento} key={elemento._id} />);
        return(
            <div>
              <select style={styles.input} className="ui simple selection dropdown fluid" name="descrSegmento" id="miListaSeg" value={permiteUpdate?argsDocum.codigoSegmento:idLista.codigoSegmento} onChange={(ev)=>handleChange(ev, argsDocum)}>
                {NivelDetalleES}
              </select>
            </div>
        )
    };
  
  const DetalleNivelGA = props => {
    return (
      <option dato1={props.elemento.codigoGrupoAfin} dato2={props.elemento.descrGrupoAfin} value={props.elemento._id}>{props.elemento.codigoGrupoAfin} ={">"} {props.elemento.descrGrupoAfin}</option>
    )
  };
  
  const ListaGA = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
      const NivelDetalleGA = list.map((elemento, _id) => <DetalleNivelGA styles={styles} elemento={elemento} key={elemento._id} />);
      return(
          <div>
              <select style={styles.input} className="ui simple selection dropdown fluid" name="grupoaf" id="miListaGA" value={permiteUpdate?argsDocum.idGrupoAf:idLista.grupoaf._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
                  {/* <option style={styles.input} value="">Seleccionar...</option> */}
                  {NivelDetalleGA}
              </select>
          </div>
      )
  };

  const DetalleNivelTC = props => {
    return (
      <option dato1={props.elemento.codigoTipoCliente} dato2={props.elemento.descrTipoCliente} value={props.elemento.codigoTipoCliente}>{props.elemento.codigoTipoCliente} ={">"} {props.elemento.descrTipoCliente}</option>
    )
  };
  
  const ListaTC = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
    const NivelDetalleTC = list.map((elemento, _id) => <DetalleNivelTC styles={styles} elemento={elemento} key={elemento._id} />);
    return(
      <div>
        <select style={styles.input} className="ui simple selection dropdown fluid" name="tipocl" id="miLista1" value={permiteUpdate?argsDocum.codigoTipoCliente:idLista.tipocl.codigoTipoCliente} onChange={(ev)=>handleChange(ev, argsDocum)}>
          {/* <option style={styles.input} value="">Seleccionar...</option> */}
          {NivelDetalleTC}
        </select>
    </div>
    )
  };

  const DetalleNivelTD = props => {
    return (
      <option dato1={props.elemento.codigoTipoDoc} dato2={props.elemento.descrTipoDoc} value={props.elemento._id}>{props.elemento.codigoTipoDoc} ={">"} {props.elemento.descrTipoDoc}</option>
  )
  };
  
  const ListaTD = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
      const NivelDetalleTD = list.map((elemento, _id) => <DetalleNivelTD styles={styles} elemento={elemento} key={elemento._id} />);
      return(
          <div>
              <select style={styles.input} className="ui simple selection dropdown fluid" name="tipodoc" id="miLista" value={permiteUpdate?argsDocum.idTipoDoc:idLista.tipodoc._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
                  {NivelDetalleTD}
              </select>
          </div>
      )
  };

//dropdown DEPARTAMENTOS
const DetalleSelDe = props => {
  return (
    <option dato1={props.elemento.codigoDpto} value={props.elemento.codigoDpto}>{props.elemento.descrDpto}</option>
  )
};

const ListaDe = ({styles, handleCiudadDpto, list, codigoCiudadUA, codigoDptoUA}) => {
  const detalleDe = list.map((elemento, _id) => <DetalleSelDe elemento={elemento} key={elemento._id} />);
  let selecc = true
  if(list.length===1){
    selecc = false
  }
  if(codigoCiudadUA==="Todas..."&&codigoDptoUA==="Todos..."){
    return(
      <div>
        {selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista" onChange={()=>handleCiudadDpto()}>
            <option value="">Seleccionar...</option>
            {detalleDe}
          </select>
        }
        {!selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista">
            {detalleDe}
          </select>
        }
      </div>
    )
  }else{
    return(
      <div>
        {selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista" onChange={()=>handleCiudadDpto()}>
            {detalleDe}
          </select>
        }
        {!selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista">
            {detalleDe}
          </select>
        }
      </div>
    )
  }
};
//Fin dropdown DEPARTAMENTOS
//dropdown CIUDADES => solo ciudades del departamento seleccionado
const DetDetalleSelCi = props => {
  return(
    <option dato1={props.elemento.codigoCiudad} dato2={props.elemento.codigoCiudadInterno?props.elemento.codigoCiudadInterno:""} dato3={props.elemento.codBarrasRdo?props.elemento.codBarrasRdo:""} value={props.elemento.codigoCiudad}>{props.elemento.nombreCiudad}</option>
  )
}

const DetalleSelCi = ({styles, elemento, handleZonaCiudad, codigoCiudadUA}) => {
  // const detDetalleCi = elemento.ciudades.map((elemento, i) => <DetDetalleSelCi styles={styles} elemento={elemento} key={i} />);
  let selecc = true
  if(elemento.ciudades.length===1){
    selecc = false
  }
  let detDetalleCi = []
  if(codigoCiudadUA==="Todas..."){
    detDetalleCi = elemento.ciudades.map((elemento, i) => <DetDetalleSelCi styles={styles} elemento={elemento} key={i} />);
    return (
      <div>
        {selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" onChange={()=>handleZonaCiudad()}>
            <option value="">Seleccionar...</option>
            {detDetalleCi}
          </select>
        }
        {!selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" onChange={()=>handleZonaCiudad()}>
            {detDetalleCi}
          </select>
        }
      </div>
    )
  }else{
    elemento.ciudades.forEach((elemento1, _id) => {
      if(elemento1.codigoCiudad===codigoCiudadUA){
        let niv3Det = []
        niv3Det.push(elemento1)
        detDetalleCi = niv3Det.map((elemento, i) => <DetDetalleSelCi styles={styles} elemento={elemento} key={i} />);
      }
    })
    return (
      <div>
        {selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" onChange={()=>handleZonaCiudad()}>
            {detDetalleCi}
          </select>
        }
        {!selecc  &&
          <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" onChange={()=>handleZonaCiudad()}>
            {detDetalleCi}
          </select>
        }
      </div>
    )
  }
};

const ListaCi = ({styles, handleZonaCiudad, list, argsSelDpto, codigoCiudadUA}) => {
  var detalleCi = []
  let selecc = true
  // console.log(list, argsSelDpto.codigoDpto)
  list.forEach((elemento, _id) => {
    if(elemento.codigoDpto===argsSelDpto.codigoDpto){
      let niv2Det = []
      niv2Det.push(elemento)
      detalleCi = niv2Det.map((elemento, _id) => <DetalleSelCi styles={styles} elemento={elemento}
        key={elemento._id} handleZonaCiudad={handleZonaCiudad} codigoCiudadUA={codigoCiudadUA}/>);
      if(elemento.ciudades.length===1){
        selecc = false
      }
    }
  })
  return(
    <div>
      {(!argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Seleccionar...")&&selecc ?
        <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1C" onChange={()=>handleZonaCiudad()}>
          <option value="">Seleccionar...</option>
          {detalleCi}
        </select>
      :
        <div>
          {detalleCi}
        </div>
      }
    </div>
  )
};
//Fin dropdown CIUDADES
//dropdown ZONAS => solo zonas de la ciudad seleccionada
const DetalleSelZo = props => {
  return (
      <option>{props.elemento.nombreZona}</option>
  )
};

const ListaZo = ({styles, argsSelDpto}) => {
  let lisZona = []
  lisZona.push(argsSelDpto)
  const detDetalleZo = lisZona.map((elemento, i) => <DetalleSelZo elemento={elemento} key={i} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista2">
              {detDetalleZo}
            </select>
        </div>
    )
};
//Fin dropdown ZONAS
//dropdown BARRIOS => solo barrios de la zona seleccionada
const DetDetalleSelBa = props => {
  return(
      <option dato1={props.elemento.barrio.codigoTipoDocT + "/" + props.elemento.codigoZona}
              dato2={props.elemento.barrio.numeroDocumT + "/" + props.elemento.nombreZona}
              dato3={props.elemento.barrio.descrRecursoT} dato4={props.elemento.barrio.codigoTipoDocR}
              dato5={props.elemento.barrio.numeroDocumR} dato6={props.elemento.barrio.descrRecursoR}
              value={props.elemento.barrio.codigoBarrio}>{props.elemento.barrio.nombreBarrio}</option>
  )
}

const DetalleSelBa = ({styles, elemento, handleBarrioSel}) => {
  var detDetalleBa = []
  var niv5Det = []
  elemento.forEach((elemento1, i) => {
      niv5Det.push(elemento1)
  })
  // niv5Det.push(elemento)
  // console.log(niv5Det)
  detDetalleBa = niv5Det.map((elemento, i) => <DetDetalleSelBa styles={styles} elemento={elemento} key={i} />);
  return (
      <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista3" onChange={()=>handleBarrioSel()}>
          <option value="">Seleccionar...</option>
          {detDetalleBa}
      </select>
  )
};

const ListaBa = ({styles, handleBarrioSel, list, argsSelDpto}) => {
  var detalleBa = []
  list.forEach((elemento, _id) => {
    if(argsSelDpto.codigoDpto && elemento.ciudades.length>0 && elemento.codigoDpto===argsSelDpto.codigoDpto){
      elemento.ciudades.forEach((elemento1, i) => {
        if(argsSelDpto.codigoCiudad && elemento1.codigoCiudad===argsSelDpto.codigoCiudad){
          if(argsSelDpto.codigoDpto && elemento1.zonas.length>0 && elemento.codigoDpto===argsSelDpto.codigoDpto){
            let lisBarr = []
            elemento1.zonas.forEach((elemento2, ii) => {
              elemento2.barrios.forEach((elemento3, ii) => {
                lisBarr.push({barrio: elemento3, codigoZona: elemento2.codigoZona,
                              nombreZona: elemento2.nombreZona})
              })
            })
            lisBarr = _.orderBy(lisBarr, ['barrio.nombreBarrio'])

            let niv4Det = []
            niv4Det.push(lisBarr)
            detalleBa = niv4Det.map((elemento, i) => <DetalleSelBa styles={styles} elemento={elemento} key={i} handleBarrioSel={handleBarrioSel}/>);
          }
        }
      })
    }
  })
  return(
    <div>
      {!argsSelDpto.descrDpto||!argsSelDpto.nombreCiudad||
        argsSelDpto.descrDpto==="Seleccionar..."||argsSelDpto.nombreCiudad==="Seleccionar..." ?
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista3B" onChange={()=>handleBarrioSel()}>
            <option value="">Seleccionar...</option>
            {detalleBa}
          </select>
      :
        <div>
          {detalleBa}
        </div>
      }
    </div>
  )
};
//Fin dropdown BARRIOS

  // // Cambiar dirección
  // const ListaDirAct = ({linea1, linea2, linea3, linea4}) => {
  //   return(
  //     <tbody className=''>
  //       <tr className=''>
  //         <td className=''>{linea1}</td>
  //       </tr>
  //       <tr className=''>
  //         <td className=''>{linea2}</td>
  //       </tr>
  //       <tr className=''>
  //         <td className=''>{linea3}</td>
  //       </tr>
  //       <tr className=''>
  //         <td className=''>{linea4}</td>
  //       </tr>
  //     </tbody>
  //   )
  // };
  // // FIN Cambiar dirección

//dropdown TIPO VIA 1
const DetalleLista = props => {
  let campo1 = ""
  if(props.seleccLista==="descrTipoVia1"||props.seleccLista==="descrTipoVia2"){
    campo1=props.elemento.descrTipoVia
  }
  if(props.seleccLista==="descrTipoUnd1"||props.seleccLista==="descrTipoUnd2"){
    campo1=props.elemento.descrTipoUnd
  }
  if(props.seleccLista==="descrTiUndMat"){
    campo1=props.elemento.descrTiUndMat
  }
  if(props.seleccLista==="descrUndMat"){
    campo1=props.elemento.descrUndMat
  }
  if(props.seleccLista==="descrEstrato"){
    campo1=props.elemento.descrEstrato
  }

  return (
    <option>{campo1}</option>
  )
};

const Lista = ({styles, seleccLista, list, handleLista4}) => {
  const detalleLista = list.map((elemento, _id) => <DetalleLista elemento={elemento} seleccLista={seleccLista} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name={seleccLista} id={seleccLista} onChange={(ev)=>handleLista4(ev, seleccLista)}>
        <option value="">Seleccionar...</option>
        {detalleLista}
      </select>
    </div>
  )
};
//Fin dropdown TIPO VIA 1

  class VerCli2 extends React.Component {
    state={
        argsDocum: {contrato: this.props.idLista.contrato,
                    infAdic1: !this.props.idLista.infAdic1?'':this.props.idLista.infAdic1,
                    nombreCliente: this.props.idLista.nombreCliente,
                    apellidoCliente: this.props.idLista.apellidoCliente,
                    sexoCliente: this.props.idLista.sexoCliente,
                    eMail: !this.props.idLista.eMail?'':this.props.idLista.eMail,
                    fechaCumple: !this.props.idLista.fechaCumple?'':this.props.idLista.fechaCumple.substr(0, 10),
                    descrEstrato: this.props.idLista.descrEstrato,
                    codigoSegmento: this.props.idLista.codigoSegmento?this.props.idLista.codigoSegmento:"",
                    descrSegmento: this.props.idLista.descrSegmento?this.props.idLista.descrSegmento:"",
                    cicloFact: this.props.idLista.cicloFact?this.props.idLista.cicloFact:this.props.list8[0].cicloFact,
                    telefono1: !this.props.idLista.telefono1?'':this.props.idLista.telefono1,
                    telefono2: !this.props.idLista.telefono2?'':this.props.idLista.telefono2,
                    telefono3: !this.props.idLista.telefono3?'':this.props.idLista.telefono3,
                    referencia1: !this.props.idLista.referencia1?'':this.props.idLista.referencia1,
                    telefonoRef1: !this.props.idLista.telefonoRef1?'':this.props.idLista.telefonoRef1,
                    referencia2: !this.props.idLista.referencia2?'':this.props.idLista.referencia2,
                    telefonoRef2: !this.props.idLista.telefonoRef2?'':this.props.idLista.telefonoRef2,
                    observaciones: !this.props.idLista.observaciones?'':this.props.idLista.observaciones,
                    idTipoDoc: this.props.idLista.tipodoc._id,
                    codigoTipoDoc: this.props.idLista.tipodoc.codigoTipoDoc,
                    descrTipoDoc: this.props.idLista.tipodoc.descrTipoDoc,
                    numeroDoc: this.props.idLista.numeroDoc,
                    codigoTipoCliente: this.props.idLista.tipocl.codigoTipoCliente,
                    descrTipoCliente: this.props.idLista.tipocl.descrTipoCliente,
                    idGrupoAf: this.props.idLista.grupoaf._id,
                    codigoGrupoAfin: this.props.idLista.grupoaf.codigoGrupoAfin,
                    descrGrupoAfin: this.props.idLista.grupoaf.descrGrupoAfin,
                    _id: this.props.idLista._id,
                    descrOtrosPagCl: "Seleccionar...", codigoImpto: "", descrImpto: "",
                    porcImpto: "", descrClaseServ: "",
                    codigoTarifa: this.props.idLista.tarifa?this.props.idLista.tarifa.codigoTarifa:"",
                    descrTarifa: this.props.idLista.tarifa?this.props.idLista.tarifa.descrTarifa:"",
                    fechaPS: ""},
        argsDocumMNF: {contrato: this.props.idLista.contrato, agno: "Seleccionar...",
                    mes: "Seleccionar...", observaciones: ""},
        valchkbox: this.props.idLista.sexoCliente,
        stListServTarAct: this.props.idLista.tarifa?this.props.idLista.tarifa:{},
        stListServOfAct: this.props.idLista.oferta?this.props.idLista.oferta:{},
        stListEquiCliAct: this.props.idLista.equipos?this.props.idLista.equipos:[],
        idListaP: [], idListaF: [], idListaNot: [], listFactDetN: [], stObservacNota: "",
        totNota: 0, notaProc: false, stConcepto: "", stValor: 0, stEntro: 0, stImprFact: false,
        stImprRC: false, clientesFra: [], razonap: "", fechaPago: "", permitirAnular: true,
        argsSelDpto: {}, errorAdd: [],
        confirmaAct: false, open: false, anular_updfechapago: "", fechaHoy: "",
        confDatos_EnvCorreo: "",
        datosConfirmados: this.props.idLista.datosConfirmados?this.props.idLista.datosConfirmados:"NO",
        // _isMounted: true
      }

      handleCiudadDpto = () => {
        this.setState({argsSelDpto: {}})
        var miLista = document.getElementById("miLista");
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['descrDpto'] = miLista.options[miLista.selectedIndex].text
        if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
          argsSelDpto['codigoDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
          argsSelDpto['_id'] = miLista.options[miLista.selectedIndex].value
        }else{
          argsSelDpto['descrDpto'] = "Seleccionar..."
          argsSelDpto['codigoDpto'] = ""
          argsSelDpto['_id'] = ""
        }
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['nombreCiudad'] = "Seleccionar..."           
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
    
        this.setState({argsSelDpto});
      }
    
      handleZonaCiudad = () => {
        var miLista = document.getElementById("miLista1");
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = miLista.options[miLista.selectedIndex].text
        if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
          argsSelDpto['codigoCiudad'] = ""
          argsSelDpto['codigoCiudadInterno'] = ""
          argsSelDpto['codBarrasRdo'] = ""
        }else{
          argsSelDpto['codigoCiudad'] = miLista.options[miLista.selectedIndex].value
          argsSelDpto['codigoCiudadInterno'] = miLista.options[miLista.selectedIndex].attributes[1].value
          argsSelDpto['codBarrasRdo'] = miLista.options[miLista.selectedIndex].attributes[2].value
        }
        this.setState({argsSelDpto});
      }
    
      handleBarrioSel = () => {
        var miLista = document.getElementById("miLista3");
        const argsSelDpto = this.state.argsSelDpto
    
        if(miLista.options[miLista.selectedIndex].attributes[1]){
          let dato1 = miLista.options[miLista.selectedIndex].attributes[0].value
          let dato2 = miLista.options[miLista.selectedIndex].attributes[1].value
    
          let posic1 = dato1.indexOf("/")
          argsSelDpto['codigoTipoDocT'] = dato1.substr(0, posic1)
          argsSelDpto['codigoZona'] = dato1.substr(posic1+1)
    
          posic1 = dato2.indexOf("/")
          argsSelDpto['numeroDocumT'] = dato2.substr(0, posic1)
          argsSelDpto['nombreZona'] = dato2.substr(posic1+1)
        }
        argsSelDpto['nombreBarrio'] = miLista.options[miLista.selectedIndex].text
        argsSelDpto['codigoBarrio'] = miLista.options[miLista.selectedIndex].value
        argsSelDpto['descrRecursoT'] = miLista.options[miLista.selectedIndex].attributes[2]?miLista.options[miLista.selectedIndex].attributes[2].value:null
        argsSelDpto['codigoTipoDocR'] = miLista.options[miLista.selectedIndex].attributes[3]?miLista.options[miLista.selectedIndex].attributes[3].value:null
        argsSelDpto['numeroDocumR'] = miLista.options[miLista.selectedIndex].attributes[4]?miLista.options[miLista.selectedIndex].attributes[4].value:null
        argsSelDpto['descrRecursoR'] = miLista.options[miLista.selectedIndex].attributes[5]?miLista.options[miLista.selectedIndex].attributes[5].value:null
    // console.log(argsSelDpto)
        this.setState({argsSelDpto});
      }

      handleCpto = (ev) => {
        const argsDocum = this.state.argsDocum
        var miLista = document.getElementById("miListaCpto");
        if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
          argsDocum['descrOtrosPagCl'] = "Seleccionar..."
          argsDocum['porcImpto'] = ""
          argsDocum['descrImpto'] = ""
          argsDocum['descrClaseServ'] = ""
          argsDocum['codigoImpto'] = ""
        }else{
          argsDocum['descrOtrosPagCl'] = miLista.options[miLista.selectedIndex].text
          argsDocum['porcImpto'] = miLista.options[miLista.selectedIndex].attributes[0].value?miLista.options[miLista.selectedIndex].attributes[0].value:""
          argsDocum['descrImpto'] = miLista.options[miLista.selectedIndex].value?miLista.options[miLista.selectedIndex].value:""
          argsDocum['descrClaseServ'] = miLista.options[miLista.selectedIndex].attributes[1].value?miLista.options[miLista.selectedIndex].attributes[1].value:""
          argsDocum['codigoImpto'] = miLista.options[miLista.selectedIndex].attributes[2].value?miLista.options[miLista.selectedIndex].attributes[2].value:""
        }
        this.setState({argsDocum});
      }

      handleServProg = (ev) => {
        const argsDocum = this.state.argsDocum
        var miLista = document.getElementById("miListaSP");
        if(miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
          argsDocum['codigoServicio'] = ""
          argsDocum['nombreResumido'] = ""
          argsDocum['descripcionServicio'] = "Seleccionar..."
          argsDocum['valorServicios'] = ""
        }else{
          argsDocum['codigoServicio'] = miLista.options[miLista.selectedIndex].value?miLista.options[miLista.selectedIndex].value:""
          argsDocum['nombreResumido'] = miLista.options[miLista.selectedIndex].attributes[0].value?miLista.options[miLista.selectedIndex].attributes[0].value:""
          argsDocum['descripcionServicio'] = miLista.options[miLista.selectedIndex].attributes[1].value?miLista.options[miLista.selectedIndex].attributes[1].value:""
          argsDocum['valorServicios'] = miLista.options[miLista.selectedIndex].attributes[2].value?miLista.options[miLista.selectedIndex].attributes[2].value:0
        }
        this.setState({argsDocum});
      }

      handleAgno = (ev) => {
        const argsDocumMNF = this.state.argsDocumMNF
        var miLista = document.getElementById("miListaAgno");
        argsDocumMNF['agno'] = miLista.options[miLista.selectedIndex].text
        this.setState({argsDocumMNF});
      }

      handleMes = (ev) => {
        const argsDocumMNF = this.state.argsDocumMNF
        var miLista = document.getElementById("miListaMes");
        argsDocumMNF['mes'] = miLista.options[miLista.selectedIndex].text
        this.setState({argsDocumMNF});
      }

      handleClickImpr = (ev) => {
        let clientesFra = this.props.idLista
        if(this.props.permiteHistPago){
          this.setState({stImprRC: true, clientesFra})
        }
        if(this.props.permiteHistFact){
          if(this.props.empresaArchFE==="conectic"||this.props.empresaArchFE==="supercable"||this.props.empresaArchFE==="supercablebq"){
            if(ev.target.name==="factMod2"){
              clientesFra['factMod'] = "Modelo 2"
            }else{
              clientesFra['factMod'] = "Modelo 1"
            }
          }
          this.setState({stImprFact: true, clientesFra})
        }
      }

      nextVal = async (name) => {
        const argsUpd = {
            coleccion: name,
          }
          const response = await this.props.editSeqfindOneAndUpdate({
            variables: argsUpd
          });
          return response.data.editSeqfindOneAndUpdate.seq
     }
    
      ordenarArrayAsc = (array, campo) => {
        array.sort(function (a, b) {
          return a[campo] > b[campo];
        });
      }

      handleClickidListaP = async (ev, idListaP, idPago, movimientos, fechaHoy)=>{
        ev.preventDefault()

        if(idListaP.tipo==="OP"||idListaP.tipo==="PA"||idListaP._id===idPago){
          let fechaMovimiento = idListaP.fechaCreate.substr(0, 10)
          // console.log(fechaMovimiento, fechaHoy)
          let cf_o_pa = "PA"
          if((idListaP.tipo==="OP"||idListaP.tipo==="PA")&&fechaMovimiento!==fechaHoy){
//NO permitir anular pagos de OP y PA (facturados) si no son del mismo día
            cf_o_pa = "NO_permitirAnular"
          }
          if(idListaP.tipo==="PA"&&cf_o_pa==="PA"){
            // console.log(movimientos)
//No permitir anular el pago adel si hay movim de cargo de factura posteriores a un pago adel (si se facturó)
//movimientos trae todos los movim del cliente ordenados del mas reciente al mas antiguo
            for(let i=0; i<movimientos.length; i++){
              if(movimientos[i].subTipo==="CF"||movimientos[i].subTipo==="PA"){
                cf_o_pa = movimientos[i].subTipo
                i = 99999
              }
            }
          }

          let numDiasAP = this.props.empresa.numDiasAP
          // console.log(this.props.empresa, numDiasAP)
          let fechaInicio = new Date(idListaP.fechaPago).getTime();
          let fechaFin = new Date(fechaHoy).getTime();
          let numDiasAnulPago = parseInt((fechaFin - fechaInicio) / (1000*60*60*24), 10)
          // console.log(idListaP.fechaPago, fechaHoy, fechaInicio, fechaFin, numDiasAnulPago)
          if(numDiasAnulPago>numDiasAP){
            cf_o_pa = "NO_permitirAnular"
          }
  
          if(cf_o_pa==="PA"){
            this.setState({permitirAnular: true})
          }else{
            this.setState({permitirAnular: false})
          }
        }else{
          this.setState({permitirAnular: false})
        }

        this.setState({idListaP: idListaP})
        this.setState({stImprFact: false})
        this.setState({stImprRC: false})
        this.setState({clientesFra: []})
      }

      handleClickidListaF = async (ev, idListaF)=>{
        ev.preventDefault()
        // let idRangoFact = ""
        if(idListaF.tipoGen==="mes"){
          idListaF.idRangoFact = idListaF.codProcFact
        }else{
          const indexSearch = this.props.allProcFact.allProcFact.findIndex(rango => rango.codProcFact === idListaF.codProcFact);
          if(indexSearch!==-1){
            idListaF.idRangoFact = this.props.allProcFact.allProcFact[indexSearch].idRangoFact
          }
        }
        // console.log(this.state.totNota)
        let listFactDetN = []
        // console.log(this.props.allFactRtesGroup.allFactRtesGroup, idListaF.numeroFra)
        let argsBuscarFactUsu = {}
        argsBuscarFactUsu = {tipoqry: `[{$match: {'numeroFra': '${idListaF.numeroFra}'}},
        {"$unwind": '$detalleFact'},
        {$project: {'numeroFra': 1, 'valorNC': 1, 'codBarrasRdo': 1,
            'descrClaseServ': '$detalleFact.descrClaseServ',
            'codigoServicio': '$detalleFact.codigoServicio',
            'descripcionServicio': '$detalleFact.descripcionServicio',
            'nombreResumido': '$detalleFact.nombreResumido',
            'periodo': '$detalleFact.periodo',
            'consecEnFra': '$detalleFact.consecEnFra',
            'valorSF': {
                $let: {
                    vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                    in: { $cond: { if: { $eq: [ "$$tipo", "SF" ] }, then: "$$valorTipo", else: 0 } }
                }
            },
            'valorIF': {
                $let: {
                    vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                    in: { $cond: { if: { $eq: [ "$$tipo", "IF" ] }, then: "$$valorTipo", else: 0 } }
                }
            }
          }
        },
        {$group: {_id: {numeroFra: '$numeroFra', valorNC: '$valorNC', codBarrasRdo: '$codBarrasRdo', descrClaseServ: '$descrClaseServ',
            'codigoServicio': '$codigoServicio', descripcionServicio: '$descripcionServicio',
            nombreResumido: '$nombreResumido', periodo: '$periodo', 'consecEnFra': '$consecEnFra'},
            valorSF: {$sum: '$valorSF'}, valorIF: {$sum: '$valorIF'}}},
        {$unwind: "$_id"},
            {$project: {_id: 0, 'numeroFra': '$_id.numeroFra', 'valorNC': '$_id.valorNC', 'concepto': '$_id.codBarrasRdo',
            'descrClaseServ': '$_id.descrClaseServ',
            'descripcionServicio': '$_id.descripcionServicio',
            'tipoGen': '$_id.codigoServicio',
            'codProcFact': '$_id.nombreResumido',
            'descrRecurso': '$_id.periodo',
            'totServ': '$_id.consecEnFra',                  
            'totFras': {
                $let: {
                    vars: {valorSF: '$valorSF', valorIF: '$valorIF'},
                    in: { $cond: { if: { $gt: [ "$$valorIF", 0 ] },
                      then: {$divide: [ { $multiply: [ "$$valorIF", 100 ] }, "$$valorSF" ]},
                      else: 0 } }
                }
            },
            valorSF: {$toInt: '$valorSF'}, valorIF: {$toInt: '$valorIF'}}}
          ]`
        }
        // console.log(argsBuscarFactUsu)
        let clientesFact = []
        let {data} = await this.props.allFactRtesGroup.refetch(argsBuscarFactUsu)
        if(data!==undefined){
          clientesFact = await data.allFactRtesGroup
        }
        // console.log(clientesFact)

        if(clientesFact.length>0){
          const elemento3 = clientesFact
          elemento3.forEach((elemento, i) => {
            listFactDetN.push({codigoServicio: elemento.tipoGen, valorNC: elemento.valorNC,
              descrClaseServ: elemento.descrClaseServ,
              nombreResumido: elemento.codProcFact, descripcionServicio: elemento.descripcionServicio,
              periodo: elemento.descrRecurso, consecEnFra: elemento.totServ, porcImpto: Math.round(elemento.totFras),
              valorSF: elemento.valorSF, valorIF: elemento.valorIF, nuevoValor: 0,
              _id: i, estadoSelecc: true
            });

          })
        }
        // console.log(listFactDetN)
        // if(idListaF.detalleFact){
        //   const elemento3 = idListaF.detalleFact
        //   elemento3.forEach((elemento, i) => {
        //     listFactDetN.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.descrClaseServ,
        //       nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
        //       concepto: elemento.concepto, periodo: elemento.periodo, tipo: elemento.tipo,
        //       consecEnFra: elemento.consecEnFra,
        //       valor: elemento.valor, nuevoValor: 0,
        //       _id: i, estadoSelecc: true
        //     });
        //   })
        // }

        let documFra = idListaF
        let modeloCodBarras = this.props.empresa.modeloCodBarras
        // let codBarrasRdo = this.props.codBarrasRdo
        let codBarrasRdo = clientesFact.length>0?clientesFact[0].concepto?clientesFact[0].concepto:this.props.codBarrasRdo:this.props.codBarrasRdo
        let imgSource = await codBarras(documFra, modeloCodBarras, codBarrasRdo)
        idListaF.codBarras = imgSource
// console.log(codBarrasRdo)
        this.setState({listFactDetN, idListaF, totNota: 0})
        this.setState({stImprFact: false})
        this.setState({stImprRC: false})
        this.setState({clientesFra: []})
        // this.setState({idListaF: idListaF})
      }

      handleClickidListaNot = async (ev, idListaNot)=>{
        ev.preventDefault()

        let listNotDetN = []
        if(idListaNot.detalleNota){
          const elemento3 = idListaNot.detalleNota
          elemento3.forEach((elemento, i) => {
            listNotDetN.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.descrClaseServ,
              nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
              concepto: elemento.concepto, periodo: elemento.periodo, tipo: elemento.tipo,
              consecEnFra: elemento.consecEnFra, valor: elemento.valor,
              _id: i
            });
          })
        }
        
        this.setState({listNotDetN, idListaNot})
        this.setState({stImprFact: false})
        this.setState({stImprRC: false})
        this.setState({clientesFra: []})
      }

      handleChange = (ev, input) => {
        // console.log(input.name)
        //   argsAdd[input.name] = input.value
        if (this.props.permiteAjP||this.props.permiteAjN||this.props.permiteNCA||this.props.permiteNCPF||this.props.permiteProgNvoServ){
          this.setState({confirmaAct: false})
          if(ev.target.name === "concepto"){
            this.setState({stConcepto: ev.target.value});
          }
          if(ev.target.name === "valor"){
            this.setState({stValor: ev.target.value});
          }
        }
        if(ev.target.name==="razonap"){
          this.setState({razonap: ev.target.value});
        }
        if(ev.target.name==="fechaPago"){
          this.setState({fechaPago: ev.target.value});
        }
        if(ev.target.name==="fechaPS"){
          const argsDocum = this.state.argsDocum
          argsDocum['fechaPS'] = ev.target.value
          this.setState({argsDocum});
        }

        if (this.props.permiteUpdate){
          let datoUpd = ""
          if(input===undefined){
            datoUpd = ev.target.name
          }else{
            if(ev.target.name===undefined){
              datoUpd = input.name
            }else{
              datoUpd = ev.target.name
            }
          }

          this.setState({confirmaAct: false})
          if(datoUpd !== "contrato"){
            const argsDocum = this.state.argsDocum
            if(datoUpd === "descrEstrato"||datoUpd === "cicloFact"){
              argsDocum[datoUpd] = ev.target.value
            }else{
              if(datoUpd === "tipodoc"){
                argsDocum['idTipoDoc'] = ev.target.value
                var miLista = document.getElementById("miLista");
                // console.log(miLista)
                argsDocum['descrTipoDoc'] = miLista.options[miLista.selectedIndex].attributes[1].value
                argsDocum['codigoTipoDoc'] = miLista.options[miLista.selectedIndex].attributes[0].value
              }else{
                if(datoUpd === "tipocl"){
                  miLista = document.getElementById("miLista1");
                  // console.log(miLista)
                  argsDocum['descrTipoCliente'] = miLista.options[miLista.selectedIndex].attributes[1].value
                  argsDocum['codigoTipoCliente'] = miLista.options[miLista.selectedIndex].attributes[0].value
                }else{
                  if(datoUpd === "grupoaf"){
                    argsDocum['idGrupoAf'] = ev.target.value
                    miLista = document.getElementById("miListaGA");
                    // console.log(miLista)
                    argsDocum['descrGrupoAfin'] = miLista.options[miLista.selectedIndex].attributes[1].value
                    argsDocum['codigoGrupoAfin'] = miLista.options[miLista.selectedIndex].attributes[0].value
                  }else{
                    if(datoUpd === "sexoCliente"){
                      // console.log(input.value)
                      // console.log(input.name)
                      // const argsDocum = this.state.argsDocum
                      argsDocum['sexoCliente'] = input.value
                      this.setState({argsDocum});
            
                      this.setState({ valchkbox: input.value })
                    }else{
                      if(ev.target.name === "infAdic1"&&this.props.empresaArchFE==="conectic"){
                        let miLista = document.getElementById("miListaInfAdic");
                        argsDocum['infAdic1'] = miLista.options[miLista.selectedIndex].text
                      }else{
                        if(datoUpd === "descrSegmento"){
                          miLista = document.getElementById("miListaSeg");
                          argsDocum['codigoSegmento'] =  miLista.options[miLista.selectedIndex].value
                          argsDocum['descrSegmento'] = miLista.options[miLista.selectedIndex].text
                        }else{
                          argsDocum[datoUpd] = ev.target.value
                        }
                      }
                    }
                  }
                }
              }
            }
            this.setState({argsDocum});
          }
        }
        this.setState({stImprFact: false})
        this.setState({stImprRC: false})
        // console.log(this.state.stImprFact)
      }

    handleChangeDetFN = (ev, elemento) => {
      if(ev.target.name === "observacNota"){
        this.setState({stObservacNota: ev.target.value});
      }
      if(ev.target.name === "nuevoValor"){
        this.setState({confirmaAct: false})

        let listFactDetN=this.state.listFactDetN
        let totNota=this.state.totNota
        const indexSearch = listFactDetN.findIndex(servicio => servicio.descrClaseServ === elemento.descrClaseServ&&
                                                  servicio.descripcionServicio === elemento.descripcionServicio);
        if(indexSearch !== -1){
          totNota+=ev.target.value - listFactDetN[indexSearch].nuevoValor
          listFactDetN[indexSearch].nuevoValor = ev.target.value
        }

        this.setState({listFactDetN, totNota});
      }
      if(ev.target.name === "observacMNF"){
        this.setState({confirmaAct: false})

        const argsDocumMNF = this.state.argsDocumMNF
        argsDocumMNF['observaciones'] = ev.target.value
        this.setState({argsDocumMNF});
      }
      this.setState({stImprFact: false})
      this.setState({stImprRC: false})
      console.log(this.state.stImprFact)
    }

    handleElimMNF = async (ev, elemento)=>{
      this.setState({confirmaAct: false})
      let opcion = window.confirm('Esta usted seguro de eliminarlo ?')
      if (opcion===true) {
        const argsDel = {
          _id: elemento._id,
        }
        const response = await this.props.deleteMesNoFra({
          variables: argsDel
        });
        const {errors, success} = response.data.deleteMesNoFra;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          this.setState({errorAdd: []})
          await this.props.allMesNoFra.refetch()
        }
      }
    }

    handleSubmitMNF = async (ev, argsDocumMNF, listaMNF) => {
      let errors = []
      let indexMNF = listaMNF.findIndex(mesmnf => (mesmnf.contrato===argsDocumMNF.contrato&&mesmnf.agno===argsDocumMNF.agno&&mesmnf.mes===argsDocumMNF.mes));
      if(indexMNF!==-1){
        errors.push({path: 'Mes', message: "El mes seleccionado ya fue agregado y está pendiente por procesar"});
      }  
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let agnoHoy = fechaHoraHoy.substr(0, 4)
      let mesHoy = fechaHoraHoy.substr(5, 2)

      if(argsDocumMNF.agno&&agnoHoy===argsDocumMNF.agno&&
          argsDocumMNF.mes&&Number(mesHoy)>Number(argsDocumMNF.mes) + 1){
        errors.push({path: 'Mes', message: "El mes seleccionado no es válido"});
      }
      if(!argsDocumMNF.agno||argsDocumMNF.agno==="Seleccionar..."||
          !argsDocumMNF.mes||argsDocumMNF.mes==="Seleccionar..."||!argsDocumMNF.observaciones){
        if(!argsDocumMNF.agno||argsDocumMNF.agno==="Seleccionar..."){
          errors.push({path: 'Año', message: "Debe seleccionar el año"});
        }
        if(!argsDocumMNF.mes||argsDocumMNF.mes==="Seleccionar..."){
          errors.push({path: 'Mes', message: "Debe seleccionar el mes"});
        }
        if(!argsDocumMNF.observaciones){
          errors.push({path: 'Observaciones', message: "Debe escribir las observaciones"});
        }
      }
      this.setState({confirmaAct: false})
      if(errors.length>0){
        this.setState({errorAdd: errors})
      }else{
        let args = argsDocumMNF
        args['procesado'] = "N"
        args['fechaCreate'] = fechaHoraHoy
        const response = await this.props.createMesNoFra({
          variables: args
        });
        const {errors, success} = response.data.createMesNoFra;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var observacMNF = document.getElementById("observacMNF");
          var agno = document.getElementById("miListaAgno");
          var mes = document.getElementById("miListaMes");
          agno.options.selectedIndex = 0
          mes.options.selectedIndex = 0
          observacMNF.value = ""

          this.setState({argsDocumMNF: {contrato: this.props.idLista.contrato, agno: "Seleccionar...",
            mes: "Seleccionar...", observaciones: ""}})

          this.setState({errorAdd: []})
          await this.props.allMesNoFra.refetch()
        }
      }
    }

    handleQuestionUpdDel = async (ev) => {
      if(ev.target.attributes[1].value==="btnrazonap"||ev.target.attributes[1].value==="btnfechaPago"){
        this.setState({anular_updfechapago: ev.target.attributes[1].value})
      }
      if(ev.target.attributes[1].value==="confDatos"||ev.target.attributes[1].value==="habCambDatos"||
          ev.target.attributes[1].value==="enviar"||ev.target.attributes[1].value==="noEnviar"){
        this.setState({confDatos_EnvCorreo: ev.target.attributes[1].value})
      }

      var btnPress = await ev.target.attributes[0].value
      if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
      if(btnPress==="No"){
          this.setState({open: false})
      };
      if(btnPress==="Si"){
          this.setState({confirmaAct: true})
          this.setState({open: false})
          const myBtn = document.getElementById("btnUpdDel");
          if(myBtn){
            myBtn.click()
          }
      }
    }

    // handleConfDatos = async (ev, accion) => {
    //   // Actualiza datosConfirmados
    //   let editDatosBas = []
    //   let argsUpd = {
    //     "accionBD": this.props.editCliente,
    //     "tipoAct": "ConfHabDatosBas",
    //     "contrato": this.props.idLista.contrato,
    //     "datosConfirmados": accion==="Confirmar"?"SI":"NO",
    //   }
    //   editDatosBas.push(argsUpd)
    //   await this.props.editCliente({
    //     variables: editDatosBas[0]
    //   });
    //   // FIN Actualiza datosConfirmados
    //   if(accion==="Confirmar"){
    //     this.setState({datosConfirmados: "SI"})
    //   }else{
    //     this.setState({datosConfirmados: "NO"})
    //   }
    //   this.setState({confirmaAct: false})
    //   this.setState({open: false})
    // }

    handleImprimirTabla = async (ev, argsDocum) => {
      // console.log(ev.target.name)
      let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
      doc.setFontSize(14);
      doc.setFontType("bold");
      let texto1 = this.props.empresa.empresaRazonSocial
      let texto2 = `${argsDocum.contrato} - ${argsDocum.nombreCliente} ${argsDocum.apellidoCliente}`
      let texto3 = ""
      let source
      if(ev.target.name==="histFinancieraPdf"){
        texto3 = "Historia financiera"

        source = document.getElementById("histFinanciera");
      }
      if(ev.target.name==="histPagosPdf"){
        texto3 = "Historial de pagos"

        source = document.getElementById("histPagos");
      }
      if(ev.target.name==="histFacturacionPdf"){
        texto3 = "Historial de facturación"

        source = document.getElementById("histFacturacion");
      }
      if(ev.target.name==="histCargosEspPdf"){
        texto3 = "Historial de cargos especiales"

        source = document.getElementById("histCargosEsp");
      }
      if(ev.target.name==="histNotPdf"){
        texto3 = "Historial de Notas Débito / Crédito"

        source = document.getElementById("histNot");
      }
      if(ev.target.name==="histAjPdf"){
        texto3 = "Historial de Ajustes Positivos / Negativos"

        source = document.getElementById("histAj");
      }
      doc.text(texto1, 108, 20, 'center')
      doc.setFontSize(12);
      doc.text(texto2, 108, 30, 'center')
      doc.text(texto3, 108, 40, 'center')

      doc.autoTable({startY: 55,
                      tableLineColor: "blue",
                      tableLineWidth: 0.1,
                      styles: {
                        // font: 'Calibri',
                        fontSize: 10,
                        lineColor: "black",
                        lineWidth: 0.1
                      },
                      headStyles: {
                        fillColor: "#bdc3c7",
                        textColor: "black",
                        fontSize: 12
                      },
                      bodyStyles: {
                        fillColor: "#E9E4F0",
                        textColor: "black"
                      },
                      alternateRowStyles: {
                        fillColor: "white",
                        textColor: "black"
                      },
                      html: source,
                      margin: {top: 10, left: 2, right: 2},})
      // let finalY = doc.previousAutoTable.finalY; //para traer posicion final de la tabla
      // doc.text("TOTAL", 50, finalY + 15);
      doc.autoPrint({variant: 'non-conform'});
      // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
      // => UTILIZAR
      const pdfBlob = doc.output('blob');
      const url = URL.createObjectURL(pdfBlob);
      window.open(url);
      // doc.save('histfinanc.pdf')
    }

    
//ACTUALIZAR BD
    crudBD = async (operacionCRUD, args, i)=>{
      if(args.ctrlCampo === 'CRUD'){
        const {data} = await operacionCRUD({variables: args});
  
  //Se utiliza para traer el _id del documento creado
        if(args.ctrl_id === 'SI_ID'){
          if(Object.values(data)[0]._id){
            return Object.values(data)[0]._id
          }else{
            return 0
          }
        }
      }else{
        if(args.ctrlCampo === "MANY"){
          await operacionCRUD({
            variables: args
          });
        }
      }
    }
    updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
      let codigo = 0
      if(argsCrud[0].ctrl_id === 'SI_ID'){
        codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
      }else{
        await this.crudBD(crudColecc[0], argsCrud[0], 0)
      }
      if(codigo!==0){
        for(let i=1; i<totDocCRUD; i++){argsCrud[i]._id = codigo}
      }
      for(let i=1; i<totDocCRUD; i++){await this.crudBD(crudColecc[i], argsCrud[i], i)}
console.log("final")
    }
  
    async componentDidMount(){
      await this.props.allHistCliente.refetch()
      await this.props.allMovRtesCC.refetch()

      if(!this.state.argsSelDpto.codigoDpto){
        if(this.props.allDirmayor.allDirmayor){
          if(this.props.allDirmayor.allDirmayor.length===1||this.props.codigoCiudadUA!=="Todas..."||this.props.codigoDptoUA!=="Todos..."){
            const argsSelDpto = {}
            if(this.props.codigoCiudadUA!=="Todas..."){
              this.props.allDirmayor.allDirmayor.forEach((elemento, _id) => {
                elemento.ciudades.forEach((elemento1, _id) => {
                  if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                    argsSelDpto['codigoDpto'] = elemento.codigoDpto
                    argsSelDpto['descrDpto'] = elemento.descrDpto
                    argsSelDpto['_id'] = elemento._id
    
                    argsSelDpto['nombreCiudad'] = elemento1.nombreCiudad
                    argsSelDpto['codigoCiudad'] = elemento1.codigoCiudad
                    argsSelDpto['codigoCiudadInterno'] = elemento1.codigoCiudadInterno
                    argsSelDpto['codBarrasRdo'] = elemento1.codBarrasRdo
                  }
                })
              })
            }else{
              let indexSearch = 0
              if(this.props.allDirmayor.allDirmayor.length>1){
                if(this.props.codigoDptoUA!=="Todos..."){
                  indexSearch = this.props.allDirmayor.allDirmayor.findIndex(elemento => elemento.codigoDpto===this.props.codigoDptoUA);
                }
              }
              if(indexSearch!==-1){
                argsSelDpto['codigoDpto'] = this.props.allDirmayor.allDirmayor[indexSearch].codigoDpto
                argsSelDpto['descrDpto'] = this.props.allDirmayor.allDirmayor[indexSearch].descrDpto
                argsSelDpto['_id'] = this.props.allDirmayor.allDirmayor[indexSearch]._id
                if(this.props.allDirmayor.allDirmayor[indexSearch].ciudades.length===1){
                  argsSelDpto['nombreCiudad'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].nombreCiudad
                  argsSelDpto['codigoCiudad'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codigoCiudad
                  argsSelDpto['codigoCiudadInterno'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codigoCiudadInterno
                  argsSelDpto['codBarrasRdo'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codBarrasRdo
                }else{
                  argsSelDpto['nombreCiudad'] = "Seleccionar..."
                  argsSelDpto['codigoCiudad'] = ""
                  argsSelDpto['codigoCiudadInterno'] = ""
                  argsSelDpto['codBarrasRdo'] = ""        
                }
              }
            }
            this.setState({argsSelDpto});
          }
        }
      }
    }

    async componentDidUpdate (prevProps, prevState){
      // this.setState({_isMounted: true})
      let miLista = document.getElementById("miLista");
      if(miLista){
        if(this.state.argsSelDpto.descrDpto&&
            this.state.argsSelDpto.descrDpto!==miLista.options[miLista.selectedIndex].text&&
            miLista.options[miLista.selectedIndex].text==="Seleccionar..."&&this.props.codigoDptoUA==="Todos..."){
          let argsSelDpto = {}
          argsSelDpto['codigoDpto'] = ""
          argsSelDpto['descrDpto'] = "Seleccionar..."
          argsSelDpto['_id'] = ""
  
          argsSelDpto['nombreCiudad'] = "Seleccionar..."
          argsSelDpto['codigoCiudad'] = ""
          argsSelDpto['codigoCiudadInterno'] = ""
          argsSelDpto['codBarrasRdo'] = ""
          this.setState({argsSelDpto})
        }else{
          if(this.props.allDirmayor.allDirmayor&&this.state.argsSelDpto.codigoDpto&&!this.state.argsSelDpto.codigoCiudad){
            this.props.allDirmayor.allDirmayor.forEach((elemento, _id) => {
              if(elemento.codigoDpto===this.state.argsSelDpto.codigoDpto){
                elemento.ciudades.forEach((elemento1, _id) => {
                  if(elemento.ciudades.length===1){
                    const argsSelDpto = this.state.argsSelDpto
                    argsSelDpto['nombreCiudad'] = elemento1.nombreCiudad
                    argsSelDpto['codigoCiudad'] = elemento1.codigoCiudad
                    argsSelDpto['codigoCiudadInterno'] = elemento1.codigoCiudadInterno
                    argsSelDpto['codBarrasRdo'] = elemento1.codBarrasRdo
                    this.setState({argsSelDpto});
                  }
                })
              }
            })
          }  
        }
        // console.log(this.state.argsSelDpto.descrDpto, miLista.options[miLista.selectedIndex].text)
      }
  
      miLista = document.getElementById("miLista1");
      if(miLista){
        if(this.state.argsSelDpto.nombreCiudad&&
            this.state.argsSelDpto.nombreCiudad!==miLista.options[miLista.selectedIndex].text&&
            miLista.options[miLista.selectedIndex].text==="Seleccionar..."&&this.props.codigoCiudadUA==="Todas..."){
          let argsSelDpto = this.state.argsSelDpto
          argsSelDpto['nombreCiudad'] = "Seleccionar..."
          argsSelDpto['codigoCiudad'] = ""
          argsSelDpto['codigoCiudadInterno'] = ""
          argsSelDpto['codBarrasRdo'] = ""
          this.setState({argsSelDpto})
        }
        // console.log(this.state.argsSelDpto.nombreCiudad, miLista.options[miLista.selectedIndex].text)
      }

      if(!this.state.argsSelDpto.codigoDpto||
        (this.props.args.descrTipoOS&&this.props.args.descrTipoOS==="Seleccionar..."&&
            this.state.argsSelDpto.nombreBarrio)){
              // console.log(this.state.argsSelDpto.codigoDpto, this.props.args.descrTipoOS, this.state.argsSelDpto.nombreBarrio)
      if(this.props.allDirmayor.allDirmayor){
        if(this.props.allDirmayor.allDirmayor.length===1||this.props.codigoCiudadUA!=="Todas..."||
            this.props.codigoDptoUA!=="Todos..."){
              // console.log(this.props.allDirmayor.allDirmayor.length, this.props.codigoCiudadUA, this.props.codigoDptoUA)
          let argsSelDpto = this.state.argsSelDpto
          if(this.props.codigoCiudadUA!=="Todas..."){
            argsSelDpto = {}
            // console.log(this.props.allDirmayor.allDirmayor)
            this.props.allDirmayor.allDirmayor.forEach((elemento, _id) => {
              elemento.ciudades.forEach((elemento1, _id) => {
                // console.log("11", elemento1.codigoCiudad, this.props.codigoCiudadUA)
                if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                  // console.log("22")
                  argsSelDpto['codigoDpto'] = elemento.codigoDpto
                  argsSelDpto['descrDpto'] = elemento.descrDpto
                  argsSelDpto['_id'] = elemento._id
  
                  argsSelDpto['nombreCiudad'] = elemento1.nombreCiudad
                  argsSelDpto['codigoCiudad'] = elemento1.codigoCiudad
                  argsSelDpto['codigoCiudadInterno'] = elemento1.codigoCiudadInterno
                  argsSelDpto['codBarrasRdo'] = elemento1.codBarrasRdo

                  this.setState({argsSelDpto});
                }
                // console.log("33")
              })
            })
          }else{
            // console.log("11", this.props.codigoDptoUA)
            let indexSearch = 0
            if(this.props.allDirmayor.allDirmayor.length>1){
              if(this.props.codigoDptoUA!=="Todos..."){
                indexSearch = this.props.allDirmayor.allDirmayor.findIndex(elemento => elemento.codigoDpto===this.props.codigoDptoUA);
              }
            }
            if(indexSearch!==-1){
              argsSelDpto = {}
              argsSelDpto['codigoDpto'] = this.props.allDirmayor.allDirmayor[indexSearch].codigoDpto
              argsSelDpto['descrDpto'] = this.props.allDirmayor.allDirmayor[indexSearch].descrDpto
              argsSelDpto['_id'] = this.props.allDirmayor.allDirmayor[indexSearch]._id
              if(this.props.allDirmayor.allDirmayor[indexSearch].ciudades.length===1){
                argsSelDpto['nombreCiudad'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].nombreCiudad
                argsSelDpto['codigoCiudad'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codigoCiudad
                argsSelDpto['codigoCiudadInterno'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codigoCiudadInterno
                argsSelDpto['codBarrasRdo'] = this.props.allDirmayor.allDirmayor[indexSearch].ciudades[0].codBarrasRdo
              }else{
                argsSelDpto['nombreCiudad'] = "Seleccionar..."
                argsSelDpto['codigoCiudad'] = ""
                argsSelDpto['codigoCiudadInterno'] = ""
                argsSelDpto['codBarrasRdo'] = ""        
              }
              this.setState({argsSelDpto});
            }
          }
        }
      }
    }




      if(this.props.editClienteMany&&this.state.stEntro<3){
        this.setState({stEntro: this.state.stEntro + 1})
      }
      if(this.props.editClienteMany&&this.state.stEntro===1){
        let actCli = [], actCliMany = [], actCliMany1 = []
        const response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha

        let argsUpd = {}
        argsUpd = {
          "tipoAct": "EditarCliUpd",
          "contrato": this.state.argsDocum.contrato,
          "fechaUltView": fechaHoraHoy,
          "usuarioUltView": sessionStorage.getItem('userLogin'),
        }
        actCli.push(argsUpd)

        actCli.forEach((elemento, ii) => {
          actCliMany.push(elemento)
        })
        actCliMany1.push({cliente: actCliMany})

        let numDocCRUD = 0, totDocCRUD = 1
        let argsCrud = [], crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editClienteMany)
        }

        argsCrud[numDocCRUD] = actCliMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editClienteMany

        this.updColecc(crudColecc, argsCrud, totDocCRUD)
// console.log("histcli")
//         await this.props.allHistCliente.refetch()
      }
      // console.log(this.state.stImprFact, this.state.clientesFra, prevState.clientesFra, this.state.stImprRC)
      if(this.state.clientesFra!==prevState.clientesFra&&(this.state.stImprFact||
        this.state.stImprRC)){
        this.setState({stImprFact: false})
        this.setState({stImprRC: false})
        this.setState({clientesFra: []})
      }
      if(this.props.permiteNDF!==prevProps.permiteNDF){
        this.setState({idListaP: [], idListaF: [], listFactDetN: [], totNota: 0, notaProc: false})
      }
      if(this.props.permiteAjP!==prevProps.permiteAjP){
        this.setState({stConcepto: "", stValor: 0})
      }
      if(this.props.permiteNCPF!==prevProps.permiteNCPF){
        const argsDocum = this.state.argsDocum
        argsDocum['descrOtrosPagCl'] = "Seleccionar..."
        argsDocum['porcImpto'] = ""
        argsDocum['descrImpto'] = ""
        argsDocum['descrClaseServ'] = ""
        argsDocum['codigoImpto'] = ""
        this.setState({argsDocum});
      }
      if(this.props.permiteProgNvoServ!==prevProps.permiteProgNvoServ){
        const argsDocum = this.state.argsDocum
        if(this.props.permiteProgNvoServ&&this.props.listPS&&this.props.listPS.length===0){
          argsDocum['codigoServicio'] = ""
          argsDocum['nombreResumido'] = ""
          argsDocum['descripcionServicio'] = "Seleccionar..."
          argsDocum['valorServicios'] = ""
        }
        if(this.props.permiteProgNvoServ&&this.props.listPS&&this.props.listPS.length===1){
          argsDocum['id_ProgServ'] = this.props.listPS[0]._id
          argsDocum['descripcionServicio'] = this.props.listPS[0].descripcionServicio
        }
        this.setState({argsDocum});
      }

      // console.log(this.state.fechaHoy)
      // if(!this.state.fechaHoy&&this.state._isMounted){
      if(!this.state.fechaHoy){
        // this.setState({_isMounted: true})
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        let fechaHoy = fechaHoraHoy.substr(0, 10)
        // console.log("11")
        this.setState({fechaHoy})
        // console.log("22")
      }
      // console.log(this.state.stImprFact)
      // this.setState({_isMounted: true})
    }

  //   componentWillUnmount() {
  //     console.log("componentWillUnmount")
  //     // this.setState({_isMounted: false})
  //     this.setState({_isMounted: false})
  //  }

  render(){
    const {argsDocum, argsDocumMNF, stListServTarAct, stListServOfAct, stListEquiCliAct, idListaP, idListaF,
      idListaNot, listFactDetN, totNota, stObservacNota, stConcepto, stValor, stImprFact, clientesFra,
      razonap, fechaPago, permitirAnular, argsSelDpto, errorAdd, stImprRC, confirmaAct, open,
      anular_updfechapago, fechaHoy, confDatos_EnvCorreo, datosConfirmados} = this.state;
    // console.log(this.state.argsDocum)
    // console.log(this.props.listPS)
    // console.log(argsSelDpto)
    // console.log(this.props.idLista)
    // console.log(this.props.args)
    // console.log(fechaHoy)
    // console.log(sessionStorage.getItem('userLogin'))
    // console.log(sessionStorage.getItem('token'))
    // console.log(anular_updfechapago)
    // console.log(datosConfirmados)
    //Para cambiar FACHAPAGO => ENTRE 15 DIAS ANTES Y HOY

    let list1 = []
    let list2 = []
    let list3 = []
    let list4 = []
    let list5 = []
    let listaPS = []
    if(this.props.listPS&&this.props.listPS.length===1){
      listaPS = this.props.listPS
    }

    if(this.props.permiteUpdateDir){
      if(this.props.allDirmayor.allDirmayor){list1 = this.props.allDirmayor.allDirmayor}
      if(this.props.allTipoVia.allTipoVia){list2 = this.props.allTipoVia.allTipoVia}
      if(this.props.allTipoUnd.allTipoUnd){list3 = this.props.allTipoUnd.allTipoUnd}
      if(this.props.allTiUndMat.allTiUndMat){list4 = this.props.allTiUndMat.allTiUndMat}
      if(this.props.allUndMat.allUndMat){list5 = this.props.allUndMat.allUndMat}

      if(list1){
        // let listaDir = list1
        if(this.props.allDirmayor.allDirmayor){
          // list1 = this.props.allDirmayor.allDirmayor
          let listaDir = this.props.allDirmayor.allDirmayor
          if(this.props.codigoDptoUA!=="Todos..."){
            listaDir = listaDir.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA)
          }
          if(this.props.codigoCiudadUA!=="Todas..."){
            let listaD = []
            listaDir.forEach((elemento, _id) => {
              if(listaD.length===0){
                elemento.ciudades.forEach((elemento1, _id) => {
                  if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                    listaD.push(elemento)
                  }
                })
              }
            })
            list1 = listaD
            let dpto = document.getElementById("miLista");
            if(dpto){
              dpto.options.selectedIndex = 0
            }
          }else{
            list1 = listaDir
          }
        }
    
      }  
    }

    let updFechaPago = ""
    if(fechaPago){
      updFechaPago = fechaPago
    }else{
      updFechaPago = idListaP.fechaPago
    }

    //Fecha maxima para cambiarla => la de hoy
    // let fechaHoy = new Date()
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

    //Fecha minima para cambiarla => 15 dias antes de la fecha actual o la que tiene de pago si es anterior
    let fechaMin = new Date(new Date() - 1000*60*60*24*15)
    fechaMin = (fechaMin.getFullYear()) + '-' + ((fechaMin.getMonth()+1)<10?'0'+(fechaMin.getMonth()+1):(fechaMin.getMonth()+1)) + '-' + (fechaMin.getUTCDate()<10?'0'+fechaMin.getUTCDate():fechaMin.getUTCDate())
    if(fechaMin>updFechaPago){
      fechaMin = updFechaPago
    }
    // console.log(fechaHoy, fechaMin)
    //FIN Para cambiar FACHAPAGO

    //Fecha minima para cambiarla => dia siguiente
    let fechaMinPS = new Date(new Date() + 1000*60*60*24*2)
    fechaMinPS = (fechaMinPS.getFullYear()) + '-' + ((fechaMinPS.getMonth()+1)<10?'0'+(fechaMinPS.getMonth()+1):(fechaMinPS.getMonth()+1)) + '-' + (fechaMinPS.getUTCDate()<10?'0'+fechaMinPS.getUTCDate():fechaMinPS.getUTCDate())
    let updFechaPS = ""
    if(argsDocum.fechaPS){
      updFechaPS = argsDocum.fechaPS
    }else{
      updFechaPS = ""
    }

    if(fechaMinPS>updFechaPago){
      fechaMinPS = updFechaPago
    }

    // console.log(updFechaPago)
    let lista4 = []
    let cptosOP = []
    if(this.props.permiteAjP||this.props.permiteAjN||this.props.permiteNDF||this.props.permiteNCF||this.props.permiteNCA){
      lista4 = this.props.list4.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)
    }
    
    let listaMNF = []
    if(this.props.allMesNoFra.allMesNoFra){
      listaMNF = this.props.allMesNoFra.allMesNoFra
      if(this.props.permiteMNF){
        listaMNF = listaMNF.filter(elemento => elemento.procesado==="N")
      }
    }

    if(this.props.permiteNCPF){
      // console.log(this.props.list4)
      cptosOP = this.props.list4
      cptosOP = _.orderBy(cptosOP, ['descrOtrosPagCl'], ['asc'])
    }
    let servTar = []
    if(this.props.permiteProgNvoServ){
      if(this.props.allTarifa.allTarifa){
        let serviciosExistentes = [];
        if(this.props.idLista.tarifa&&this.props.idLista.tarifa.servicios){
          serviciosExistentes = this.props.idLista.tarifa.servicios;
          servTar = this.props.allTarifa.allTarifa[0].servicios.filter(
            servicio => !serviciosExistentes.some(
              existente => existente.codigoServicio === servicio.codigoServicio
            )
          );
        }

        // servTar = this.props.allTarifa.allTarifa[0].servicios
        servTar = _.orderBy(servTar, ['descripcionServicio'], ['asc'])
      }
    }

    // console.log(cptosOP)
    let estadoCliente = this.props.idLista.estadoCliente
    let saldoPendiente = this.props.idLista.saldoPendiente
    let colorServicio = "#302b63"
    if(this.props.idLista.tarifa&&this.props.idLista.tarifa.servicios){
      for(let ii=0; ii<this.props.idLista.tarifa.servicios.length; ii++){
        if(this.props.idLista.tarifa.servicios[ii].colorServicio&&this.props.idLista.tarifa.servicios[ii].colorServicio!=="#ffffff"){
          colorServicio = this.props.idLista.tarifa.servicios[ii].colorServicio
        }
      }
    }
  
    let linea1DNN = ""
    let linea2DNN = ""
    let linea3DNN = ""
    let linea4DNN = ""
    let direccion1 = ""
    let direccion2 = ""
    let recRdo = ""

    if(this.props.idLista.direccion.descrTipoVia1){
      linea1DNN = `${this.props.idLista.direccion.descrTipoVia1?this.props.idLista.direccion.descrTipoVia1:""}
        ${this.props.idLista.direccion.numeroTipoVia1?this.props.idLista.direccion.numeroTipoVia1:""}
        ${this.props.idLista.direccion.descrTipoVia2?this.props.idLista.direccion.descrTipoVia2:""}
        ${this.props.idLista.direccion.numeroTipoVia2?this.props.idLista.direccion.numeroTipoVia2:""}
        ${this.props.idLista.direccion.numeroTipoVia2F?this.props.idLista.direccion.numeroTipoVia2F:""}
        ${this.props.idLista.direccion.descrTipoUnd1?this.props.idLista.direccion.descrTipoUnd1:""}
        ${this.props.idLista.direccion.numeroTipoUnd1?this.props.idLista.direccion.numeroTipoUnd1:""}
        ${this.props.idLista.direccion.descrTipoUnd2?this.props.idLista.direccion.descrTipoUnd2:""}
        ${this.props.idLista.direccion.numeroTipoUnd2?this.props.idLista.direccion.numeroTipoUnd2:""}`

        linea2DNN = `${this.props.idLista.direccion.descrTiUndMat?this.props.idLista.direccion.descrTiUndMat:""}
        ${this.props.idLista.direccion.descrUndMat?this.props.idLista.direccion.descrUndMat:""}`

        linea3DNN = `${this.props.idLista.dirmayor.descrDpto?this.props.idLista.dirmayor.descrDpto:""}
      ${this.props.idLista.dirmayor.ciudades.nombreCiudad?", " + this.props.idLista.dirmayor.ciudades.nombreCiudad:""}`

        linea4DNN = `${this.props.idLista.dirmayor.ciudades.zonas.nombreZona?", Zona: " + this.props.idLista.dirmayor.ciudades.zonas.nombreZona:""}
        ${this.props.idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio?", Barrio: " + this.props.idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio:""}`

        direccion1 = linea1DNN + ' ' + linea2DNN
        direccion2 = linea3DNN + ' ' + linea4DNN

        recRdo = `${this.props.idLista.dirmayor.ciudades.zonas.barrios.descrRecursoR?"Recauda: " + this.props.idLista.dirmayor.ciudades.zonas.barrios.descrRecursoR:""}`
    }else{
      if(this.props.idLista.dirmayor&&this.props.idLista.dirmayor.ciudades&&this.props.idLista.dirmayor.ciudades.nombreCiudad){
        direccion2 = `${this.props.idLista.dirmayor.descrDpto?this.props.idLista.dirmayor.descrDpto:""}
          ${this.props.idLista.dirmayor.ciudades.nombreCiudad?", " + this.props.idLista.dirmayor.ciudades.nombreCiudad:""}`
      }
    }

    let marquilla = this.props.idLista.codigoMarquilla?"Marquilla: " + this.props.idLista.codigoMarquilla:""
    let descrNodo = this.props.idLista.descrNodo?"Nodo: " + this.props.idLista.descrNodo:""

    let fechaCreSist = this.props.idLista.fechaCreacionSistema?this.props.idLista.fechaCreacionSistema.substr(0, 10):""
    let fechaPriAct = this.props.idLista.fechaPrimeraActivacion?this.props.idLista.fechaPrimeraActivacion.substr(0, 10):""
    let fechaUltDX = this.props.idLista.fechaUltDX?this.props.idLista.fechaUltDX.substr(0, 10):""
    let fecgaUltRX = this.props.idLista.fecgaUltRX?this.props.idLista.fecgaUltRX.substr(0, 10):""
    let fechaUltPago = this.props.idLista.fechaUltPago?this.props.idLista.fechaUltPago.substr(0, 10):""
    let valorUltPago = this.props.idLista.valorUltPago?"$ " + general.formatNum(this.props.idLista.valorUltPago.toString()):""

    let telefonos = this.props.idLista.telefono1?this.props.idLista.telefono1 + "  ":""
    telefonos += this.props.idLista.telefono2?this.props.idLista.telefono2 + "  ":""
    telefonos += this.props.idLista.telefono3?this.props.idLista.telefono3:""
    let estrato = this.props.idLista.descrEstrato
    // let numSorteos = this.props.idLista.numSorteos?this.props.idLista.numSorteos:""
    let numSorteos = this.props.idLista.tag?this.props.idLista.tag:""
    if(numSorteos){
      numSorteos = "# para Sorteo: " + parseInt(numSorteos, 10)
    }
    let email = this.props.idLista.eMail?this.props.idLista.eMail:""
    let envFraCorreo = this.props.idLista.envFraCorreo?this.props.idLista.envFraCorreo:"N"
    let fechaCumple = this.props.idLista.fechaCumple?this.props.idLista.fechaCumple.substr(0, 10):""
    let tipocl = this.props.idLista.tipocl.descrTipoCliente
    let grupoaf = this.props.idLista.grupoaf.descrGrupoAfin

    let referencia1 = this.props.idLista.referencia1?this.props.idLista.referencia1 + "   Tel: ":""
    referencia1 += this.props.idLista.telefonoRef1?this.props.idLista.telefonoRef1 + " ":""
    let referencia2 = this.props.idLista.referencia2?this.props.idLista.referencia2 + "   Tel: ":""
    referencia2 += this.props.idLista.telefonoRef2?this.props.idLista.telefonoRef2 + " ":""

    // let fechaMora = new Date()
    // fechaMora = (fechaMora.getFullYear()) + '-' + ((fechaMora.getMonth()+1)<10?'0'+(fechaMora.getMonth()+1):(fechaMora.getMonth()+1)) + '-' + (fechaMora.getUTCDate()<10?'0'+fechaMora.getUTCDate():fechaMora.getUTCDate())
    // let diasMora = (this.props.idLista.pagueHasta&&this.props.idLista.saldoPendiente>0)?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(this.props.idLista.pagueHasta.substr(0, 10)).getTime()) / (1000*60*60*24), 10)):0
    // if(diasMora<0){
    //   diasMora = 0
    // }

    let latitud = 0, longitud = 0
    if(this.props.idLista&&this.props.idLista.ubicacion){
      latitud = this.props.idLista.ubicacion.latitude?this.props.idLista.ubicacion.latitude:0
      longitud = this.props.idLista.ubicacion.longitude?this.props.idLista.ubicacion.longitude:0
      // console.log(latitud, longitud)
    }
    let keyMaps = ""
    if(this.props.empresa.IdentificadorOperador_CUN){
      keyMaps = this.props.empresa.IdentificadorOperador_CUN
    }

    //calcular diasmora
    let fechaMora = new Date()
    fechaMora = (fechaMora.getFullYear()) + '-' + ((fechaMora.getMonth()+1)<10?'0'+(fechaMora.getMonth()+1):(fechaMora.getMonth()+1)) + '-' + (fechaMora.getUTCDate()<10?'0'+fechaMora.getUTCDate():fechaMora.getUTCDate())
    let diasMora = 0, diasMoraMayor = 0
    let movimDXCl = []
    if(this.props.idLista.saldoPendiente>0){
      // movimDXCl = this.props.list4.filter(elemento => elemento.contrato===this.props.idLista.contrato)  
      movimDXCl = this.props.list4
    // console.log(movimDXCl)
      let movimDX1 = movimDXCl.map(movim => ({
        ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta.substr(0, 10)).getTime()) / (1000*60*60*24), 10)):0}))
      let fechaHoy1 = new Date()
      let diasHoy = fechaHoy1.getUTCDate()
      let mesHoy = fechaHoy1.getMonth()+1
      // console.log(fechaHoy1, diasHoy, mesHoy)
    // console.log(this.props.idLista.contrato, movimDX1)
      movimDX1.forEach((movim, ii) => {
        diasMora = 0
        if(movim.pagueHasta&&movim.valorTotal>movim.valorPagado&&movim.valorTotal>0){
          if((movim.codigoServicio==="SISTV"||movim.codigoServicio==="SINET")&&this.props.idLista.cargoMensual>0){
    //Math.ceil redondea al entero por encima
            let mesesM = Math.ceil((movim.valorTotal - movim.valorPagado) / this.props.idLista.cargoMensual)
            if(movim.codigoServicio==="SISTV"){
              diasMora = ((mesHoy-6+mesesM) * 30) + diasHoy
            }else{
              diasMora = ((mesHoy-5+mesesM) * 30) + diasHoy - 15
            }
    // console.log(movim.contrato, movim.codigoServicio, mesesM, diasMora)
          }else{
            diasMora = movim.diasMora
          }
        }
        if(diasMora<=0){
          diasMora = 0
        }
        if(diasMora>diasMoraMayor){
          diasMoraMayor = diasMora
        }
      })
      if(diasMoraMayor>0){
        diasMora = diasMoraMayor
      }
    }
    // console.log(diasMora)
    //FIN //calcular diasmora

//TARIFA
  let listServTarAct = [];
  let tarifaAct = ""
  let rentaAct = 0
  if(stListServTarAct.codigoTarifa){
    const elemento3 = stListServTarAct
    elemento3.servicios.forEach((elemento, i) => {
      rentaAct += elemento.valorServicios
      listServTarAct.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
        estadoServicio: elemento.estadoServicio, estadoCliente: this.props.idLista.estadoCliente,
        codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
        _idSubclaseServ: elemento.subclaseserv._id, codigoSubclaseServ: elemento.subclaseserv.codigoSubclaseServ,
        descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ, _idClaseServ: elemento.subclaseserv.claseserv._id,
        codigoClaseServ: elemento.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
        numeroServicios: elemento.numeroServicios, valorServicios: elemento.valorServicios, imptos: elemento.imptos,
        valorAntesImptos: elemento.valorAntesImptos,
        _id: i, estadoSelecc: true
      });
    })
    tarifaAct = `${elemento3.codigoTarifa} => ${elemento3.descrTarifa} => Fecha vencimiento: ${elemento3.fechaVence} => Renta mensual: $${general.formatNum(rentaAct.toString())}`
// console.log(listServTarAct)
    this.ordenarArrayAsc(listServTarAct, 'descrClaseServ')
  }

    //OFERTA
    let listServOfAct = [];
    let ofertaAct = ""
    if(stListServOfAct.codigoOferta){
      const elemento3 = stListServOfAct
      elemento3.servicios.forEach((elemento, i) => {
        listServOfAct.push({codigoOferta: elemento3.codigoOferta, descrOferta: elemento3.descrOferta,
          codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
          _idSubclaseServ: elemento.subclaseserv._id, codigoSubclaseServ: elemento.subclaseserv.codigoSubclaseServ,
          descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ, _idClaseServ: elemento.subclaseserv.claseserv._id,
          codigoClaseServ: elemento.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
          porcDctoOferta: elemento.porcDctoOferta, numDiasOferta: elemento.numDiasOferta,
          fechaFinOferta: elemento.fechaFinOferta,
          fechaInicioOferta: elemento.fechaInicioOferta,
          _id: i, estadoSelecc: true
        });
      })
      ofertaAct = `${elemento3.codigoOferta} => ${elemento3.descrOferta} => Fecha inicio: ${elemento3.fechaInicioOferta}`
      this.ordenarArrayAsc(listServOfAct, 'descrClaseServ')
    }

    //EQUIPOS
    let listEquiCliAct = [];
    if(stListEquiCliAct.length>0){
      stListEquiCliAct.forEach((elemento, i) => {
        listEquiCliAct.push({numeroSerie: elemento.numeroSerie, mac: elemento.mac,
          _idClaseEqu: elemento.claseequ._id, codigoClaseEqu: elemento.claseequ.codigoClaseEqu,
          descrClaseEqu: elemento.claseequ.descrClaseEqu, _idMarcaEqu: elemento.marcaequ._id,
          codigoMarcaEqu: elemento.marcaequ.codigoMarcaEqu, descrMarcaEqu: elemento.marcaequ.descrMarcaEqu,
          _idFabriEqu: elemento.fabriequ._id, codigoFabriEqu: elemento.fabriequ.codigoFabriEqu,
          descrFabriEqu: elemento.fabriequ.descrFabriEqu,
          _id: i, estadoSelecc: true
        });
      })
      this.ordenarArrayAsc(listEquiCliAct, 'numeroSerie')
    }

    //MOVIM CC
    let listMovCCCli = [];
    if(this.props.allMovRtesCC.allMovRtesCC&&this.props.allMovRtesCC.allMovRtesCC.length>0){
      this.props.allMovRtesCC.allMovRtesCC.forEach((elemento, i) => {
        listMovCCCli.push({fechaMov: elemento.fechaMov, descripcionServicio: elemento.descripcionServicio,
          periodo: elemento.periodo, origen: elemento.origen, valorTotal: elemento.valorTotal,
          procesado: elemento.procesado, documento: elemento.documento, fechaNoFact: elemento.fechaNoFact,
          usuarioNoFact: elemento.usuarioNoFact, usuarioCreate: elemento.usuarioCreate, _id: i
        });
      })
      this.ordenarArrayAsc(listMovCCCli, 'fechaMov')
    }
    //PAGOS
    let listPago = [];
    let idPago = ""
    if(this.props.list5){
      const elemento3 = this.props.list5
      // console.log(elemento3)
      elemento3.forEach((elemento, _id) => {
        if(idPago===""&&elemento.tipo!=="OP"&&elemento.documento!=="ANULADO"){
          idPago = elemento._id
        }
        let descripcionPago = elemento.descripcionPago
        if(elemento.documento==="ANULADO"){
          descripcionPago += " - " + elemento.documento
        }
        listPago.push({fechaPago: elemento.fechaPago.substr(0, 10), descripcionPago: descripcionPago,
          numeroFra: elemento.numeroFra, numeroRC: elemento.numeroRC, saldoPendiente: elemento.saldoPendiente,
          tipo: elemento.tipo, documento: elemento.documento, usuarioCreate: elemento.usuarioCreate,
          valorEf: elemento.valorEf, valorCh: elemento.valorCh, valorTC: elemento.valorTC,
          valorTD: elemento.valorTD, valorTr: elemento.valorTr, valorTotal: elemento.valorTotal,
          detalle: elemento.detalle, razonap: elemento.razonap, fechaCreate: elemento.fechaCreate,
          _id: elemento._id, estadoSelecc: true
        });
      })
      this.ordenarArrayAsc(listPago, 'fechaPago')
    }
    // console.log(idListaP.razonap)
    let listPagoDet = [], titPagoDet = "Detalle del pago seleccionado"
    if(idListaP.detalle){
      if(idListaP.numeroRC){
        titPagoDet = "Pago " + idListaP.numeroRC
      }else{
        if(idListaP.numeroFra){
          titPagoDet = "Pago (facturado)"
        }else{
          titPagoDet = "Pago"
        }
      }
      const elemento3 = idListaP.detalle
      elemento3.forEach((elemento, i) => {
        listPagoDet.push({descrClaseServ: elemento.descrClaseServ, nombreResumido: elemento.nombreResumido,
          codigoServicio: elemento.codigoServicio, descripcionServicio: elemento.descripcionServicio,
          periodo: elemento.periodo, valorDetalle: elemento.valorDetalle,
          _id: i, estadoSelecc: true
        });
      })
    }
    // console.log(this.props.list6)

    //FACTURAS
    let listFact = [];
    if(this.props.list6){
      const elemento3 = this.props.list6
      elemento3.forEach((elemento, i) => {
        // console.log(this.props.empresa.modeloCodBarras)
        // console.log(elemento)
    //     //PARA IMPRIMIR CODIGO DE BARRAS
    //     let factCodBarras = ""
    //     if(this.props.empresa.modeloCodBarras==="1"){
    // //ultimo caracter=longitud del prefijo
    // //=> la referencia queda =>  prefijo factura + numero factura + longitud prefijo factura
    // //queda de 10 digitos => se completa con ceros a la izquierda
    //       let posic1 = elemento.numeroFra.indexOf("-")
    //       if(posic1===-1){
    //         factCodBarras = `${elemento.numeroFra}0`
    //       }else{
    //         factCodBarras = elemento.numeroFra.substr(posic1 + 1)      
    //         let prefijoFra = elemento.numeroFra.substr(0, posic1)
    //         let longPrefijo = prefijoFra.length
    //         factCodBarras = `${prefijoFra}${factCodBarras}${longPrefijo}`
    //       }
    //     }
    //     if(this.props.empresa.modeloCodBarras==="2"){
    //       factCodBarras = `${elemento.contrato}`
    //     }
    // //slice => para extraer caracteres de la derecha
    //     let valorCodBarras = `00000000000000${factCodBarras}`
    //     // valorCodBarras = valorCodBarras.slice(-14)
    //     factCodBarras = valorCodBarras.slice(-10)

    //     // factCodBarras = factCodBarras.slice(-24)

    //     // let valorCodBarras = `00000000000000${elemento.valorFactura}`
    //     // valorCodBarras = valorCodBarras.slice(-14)

    //     let fechaCodBarras
    //     if(elemento.pagueHasta){
    //       fechaCodBarras = `${elemento.pagueHasta.substr(0,4)}${elemento.pagueHasta.substr(5,2)}${elemento.pagueHasta.substr(8,2)}`
    //     }else{
    //       fechaCodBarras = `${elemento.fechaFact.substr(0,4)}${elemento.fechaFact.substr(5,2)}${elemento.fechaFact.substr(8,2)}`
    //     }

    //     // factCodBarras =  `000000000000000000000000${elemento.numeroFra}`
    //     // factCodBarras = factCodBarras.slice(-10)
    //     valorCodBarras = `00000000000000${elemento.valorFactura}`
    //     // valorCodBarras = valorCodBarras.slice(-8)
    //     valorCodBarras = valorCodBarras.slice(-10)

    //     // let textoCB = `Ê415${this.props.codBarrasRdo}8020${factCodBarras}Ê3900${valorCodBarras}Ê96${fechaCodBarras}`
    //     // let textoCBTxt = `(415)${this.props.codBarrasRdo}(8020)${factCodBarras}(3900)${valorCodBarras}(96)${fechaCodBarras}`
    //     let textoCB = `Ê415${this.props.codBarrasRdo}8020${factCodBarras}Ê3900${valorCodBarras}`
    //     let textoCBTxt = `(415)${this.props.codBarrasRdo}(8020)${factCodBarras}(3900)${valorCodBarras}`
    //     // console.log(textoCB)
    //     let canvas = document.createElement("canvas");
    //     // JsBarcode("#barcodecanvasjs", textoCB, {
    //     JsBarcode(canvas, textoCB, {
    //       format: "CODE128",
    //       ean128: true,
    //       text: textoCBTxt,
    //       lineColor: "#000000",
    //       width: 2,
    //       height: 50,
    //       // width: 2,
    //       // height: 50,
    //       displayValue: true
    //     });

    //     // let canvas = document.getElementById('barcodecanvasjs');
    //     let imgSource = canvas.toDataURL("image/png");

        listFact.push({tipoGen: elemento.tipoGen, numeroFra: elemento.numeroFra, cufe: elemento.cufe, fechaFact: elemento.fechaFact.substr(0, 10), agno: elemento.agno,
          mes: elemento.mes, valorAntesImptos: elemento.valorAntesImptos, valorFacturado: elemento.valorFacturado,
          valorFactura: elemento.valorFactura, detalleFact: elemento.detalleFact,
          codProcFact:elemento.codProcFact, contrato: elemento.contrato, codBarras: idListaF.codBarras,
          _id: i, estadoSelecc: true
        });
      })
      // console.log(listFact)
      this.ordenarArrayAsc(listFact, 'fechaFact')
    }

    let listFactDet = [], titFactura = "", titFacturaDet = "", titMNF = ""
    let titTotN = "", titTipoAjNota = ""

    if(this.props.permiteHistFact){
      titFactura = "Historial de facturación"
      titFacturaDet = "Detalle de la factura "
    }
    if(this.props.permiteNCPF){
      titTipoAjNota="Nuevo cargo próxima factura"
    }
    if(this.props.permiteProgNvoServ){
      titTipoAjNota="Programar nuevo servicio"
    }
    if(this.props.permiteNDF){
      titFactura = "Seleccionar factura para aplicar la Nota Débito"
      titFacturaDet = "Factura "
      titTotN="Total ND"
    }
    if(this.props.permiteNCF){
      titFactura = "Seleccionar factura para aplicar la Nota Crédito"
      titFacturaDet = "Factura "
      titTotN="Total NC"
    }
    if(this.props.permiteNCA){
      titTipoAjNota="Nota Crédito"
    }
    if(this.props.permiteAjP){
      titTipoAjNota="Ajuste positivo"
    }
    if(this.props.permiteAjN){
      titTipoAjNota="Ajuste negativo"
    }
    if(this.props.permiteMNF){
      titMNF="Meses que no se le van a facturar"
    }

    if(idListaF.detalleFact){
      titFacturaDet = titFacturaDet + idListaF.numeroFra
      const elemento3 = idListaF.detalleFact
      elemento3.forEach((elemento, i) => {
        listFactDet.push({descrClaseServ: elemento.descrClaseServ, nombreResumido: elemento.nombreResumido,
          descripcionServicio: elemento.descripcionServicio, concepto: elemento.concepto,
          valor: elemento.valor, nuevoValor: elemento.valor,
          _id: i, estadoSelecc: true
        });
      })
    }

    //Historial de Notas Debito/Credito
    let listNot = [];
    if(this.props.list8N){
      const elemento3 = this.props.list8N
      elemento3.forEach((elemento, i) => {
        listNot.push({numeroNota: elemento.numeroNota, fechaNota: elemento.fechaNota.substr(0, 10),
          valorAntesImptos: elemento.valorAntesImptos, valorNota: elemento.valorNota,
          tipoNota: elemento.tipoNota, detalleNota: elemento.detalleNota,
          numeroFra:elemento.numeroFra, contrato: elemento.contrato, usuarioCreate: elemento.usuarioCreate,
          _id: i
        });
      })
      this.ordenarArrayAsc(listNot, 'fechaNota')
    }

    let listNotDet = [], titNot = "", titNotDet = ""
    if(this.props.permiteHistNot){
      titNot = "Historial de Notas Débito / Crédito"
      titNotDet = "Detalle de la nota "
    }

    if(idListaNot.detalleNota){
      titNotDet = titNotDet + idListaNot.numeroNota
      const elemento3 = idListaNot.detalleNota
      elemento3.forEach((elemento, i) => {
        listNotDet.push({descrClaseServ: elemento.descrClaseServ, nombreResumido: elemento.nombreResumido,
          descripcionServicio: elemento.descripcionServicio, concepto: elemento.concepto,
          valor: elemento.valor,
          _id: i
        });
      })
    }

    //Historial de Ajustes Positivos/Negativos
    let listAj = [], titAj = "";
    if(this.props.list9){
      const elemento3 = this.props.list9
      elemento3.forEach((elemento, i) => {
        listAj.push({numeroAjuste: elemento.numeroAjuste, fechaAjuste: elemento.fechaAjuste.substr(0, 10),
          concepto: elemento.concepto, valorAjuste: elemento.valorAjuste,
          tipoAjuste: elemento.tipoAjuste, contrato: elemento.contrato, usuarioCreate: elemento.usuarioCreate,
          _id: i
        });
      })
      this.ordenarArrayAsc(listAj, 'tipoAjuste')
    }
    if(this.props.permiteHistAj){
      titAj = "Historial de Ajustes Positivos / Negativos"
    }


    // console.log(listFactDetN)
    // console.log(sessionStorage.getItem('userLogin'))
    // console.log(sessionStorage.getItem('token'))

    //Traer autorizaciones
    const a010102 = this.props.autorizacUA.findIndex( autorizac => autorizac === "010102" );
    const a010103 = this.props.autorizacUA.findIndex( autorizac => autorizac === "010103" );
    const a010104 = this.props.autorizacUA.findIndex( autorizac => autorizac === "010104" );

    const a010111 = this.props.autorizacUA.findIndex( autorizac => autorizac === "010111" );
    const a010112 = this.props.autorizacUA.findIndex( autorizac => autorizac === "010112" );

    const a01011501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01011501" );
    const a01012001 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01012001" );
    const a01012005 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01012005" );
    const a01012010 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01012010" );
    const a01012015 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01012015" );
    const a01012501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01012501" );
    const a01012505 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01012505" );
    // const a01013001 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01013001" );
    // const a01013005 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01013005" );
    const a01013501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01013501" );
    // const a01014001 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01014001" );

    let listFactCl = []
    let imprFactCl = true
    // let modeloCopiaFra = "1"
    let labelCopiaFra = "Copia factura"
    if(this.props.empresaArchFE==="conectic"||this.props.empresaArchFE==="supercable"||this.props.empresaArchFE==="supercablebq"){
      labelCopiaFra = "Copia factura modelo 1"
    }
    // console.log(stImprFact, idListaF.length, imprFactCl)
    if(stImprFact){
      if(idListaF.length===0){
        imprFactCl = false
      }
      // console.log(clientesFra)
      listFactCl.push({listFact: idListaF, clientesFra})
      // console.log(idListaF)
    }
    // console.log(listFactCl)
    // console.log(stImprFact, idListaF.length, imprFactCl)

    let listRCCl = []
    let imprRCCl = true
    // console.log(stImprRC)
    if(stImprRC){
      // console.log(idListaP)
      if(idListaP.detalle.length===0||!idListaP.numeroRC){
        imprRCCl = false
      }

      const usuActivo = this.props.allUsuarios1.allUsuarios.filter(usuario => usuario.email===idListaP.usuarioCreate)
      let nombreUA = ""
      if(usuActivo[0]){
        nombreUA = usuActivo[0].nombreUsuario
      }

      listRCCl.push({listServTar: idListaP.detalle, cliente: clientesFra, numeroRC: idListaP.numeroRC,
        nombreUA, saldoCl: idListaP.saldoPendiente, totRecibido: idListaP.valorTotal,
        fechaPago: idListaP.fechaPago})
    }

    let listHistCli = []
    if(this.props.allHistCliente.allHistCliente){
      listHistCli = this.props.allHistCliente.allHistCliente
    }

    let fechaMNF = new Date()
    let agnoActual = fechaMNF.getFullYear()
    let agnoSig = fechaMNF.getFullYear() + 1
    let listaAgno = [{_id: 1, agno: agnoActual.toString()}, {_id: 2, agno: agnoSig.toString()}]

    let listaMes = [{_id: 1, mes: "01"}, {_id: 2, mes: "02"}, {_id: 3, mes: "03"},
                    {_id: 4, mes: "04"}, {_id: 5, mes: "05"}, {_id: 6, mes: "06"},
                    {_id: 7, mes: "07"}, {_id: 8, mes: "08"}, {_id: 9, mes: "09"},
                    {_id: 10, mes: "10"}, {_id: 11, mes: "11"}, {_id: 12, mes: "12"},]

    let list3Estr = []
    if(this.props.list3){
      list3Estr = this.props.list3
    }

    // console.log(argsDocum)
    // console.log(listRCCl)
    // console.log(idListaP)
    // console.log(listFactCl)
    // console.log(idListaF)
    // console.log(clientesFra)
    // console.log(listFact)
    // console.log(permitirAnular)
    // console.log(this.props.allHistCliente.allHistCliente)
    // console.log(this.props.allMovRtesCC.allMovRtesCC)
    // console.log(this.props.permiteUpdateDir)
  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
        <i className="large hand point down yellow icon"></i>
        Cliente
      </button>
      <div>

      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
        <div>
          <h1 style={{...this.props.styles.paraH1, color: colorServicio}}>
            {argsDocum.contrato} - {argsDocum.nombreCliente} {argsDocum.apellidoCliente} - &nbsp;&nbsp;
            <span style={estadoCliente!=='ACTIVO'?this.props.styles.paraH2_02:this.props.styles.paraH2_01}>
              {estadoCliente}
            </span>
          </h1>
          <div className="ui three column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '55%'}}>
                {/* <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                  {direccion1}<br/>
                  {direccion2}&nbsp;&nbsp;&nbsp;&nbsp;{descrNodo}<br/>
                  Tel:&nbsp;{telefonos}&nbsp;&nbsp;&nbsp;&nbsp;Estrato:&nbsp;{estrato}&nbsp;&nbsp;&nbsp;&nbsp;{marquilla}&nbsp;&nbsp;&nbsp;&nbsp;{recRdo}<br/>
                  Correo:&nbsp;{email}&nbsp;&nbsp;&nbsp;&nbsp;Fecha de cumpleaños:&nbsp;{fechaCumple}
                </p> */}
                <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                  {direccion1}<br/>
                  {direccion2}&nbsp;&nbsp;&nbsp;&nbsp;{descrNodo}<br/>
                  Estrato:&nbsp;{estrato}&nbsp;&nbsp;&nbsp;&nbsp;{marquilla}&nbsp;&nbsp;&nbsp;&nbsp;{recRdo}<br/>
                </p>
              </div>
              <div className="column" style={{width: '15%'}}>
                <p style={{color: diasMora>0?'red':'#302b63', fontStyle: 'italic', paddingTop: '0.7em', textAlign: 'center'}}>
                  Días en mora<br/>
                  {diasMora}<br/>
                  {numSorteos}
                </p>
              </div>
              <div className="column" style={{width: '30%'}}>
                <p>
                  <span style={{background: '#7F7FD5', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                    Saldo: &nbsp;&nbsp;
                    <span style={{color: '#302b63', fontSize: '2em'}}> ${general.formatNum(saldoPendiente.toString())}</span>
                  </span>
                </p>
              </div>
            </div>
          </div>

          {(!this.props.permiteUpdate&&!this.props.permiteUpdateDir&&!this.props.permiteDelete&&
              !this.props.permiteHistFinanc&&
              !this.props.permiteHistPago&&!this.props.permiteHistFact&&
              !this.props.permiteHistNot&&!this.props.permiteHistAj&&
              !this.props.permiteNDF&&!this.props.permiteNCF&&!this.props.permiteNCA&&!this.props.permiteNCPF&&
              !this.props.permiteProgNvoServ&&!this.props.permiteAjP&&!this.props.permiteAjN&&!this.props.permiteMNF)
            ?
              <Modal open={open} size="tiny" style={this.props.styles.modal} trigger={
                <div className="ui two column stackable grid" style={{marginTop: '0em'}}>
                  <div className="row container" style={{paddingTop: '0em'}}>
                    <div className="column" style={{width: '75%'}}>
                      <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                          Tel:&nbsp;{telefonos}&nbsp;&nbsp;&nbsp;&nbsp;Correo:&nbsp;{email}&nbsp;&nbsp;&nbsp;&nbsp;Fecha de cumpleaños:&nbsp;{fechaCumple}&nbsp;&nbsp;&nbsp;&nbsp;
                        {(a010102!==-1&&datosConfirmados==="NO") &&
                          <Button name="btnUpdDel" id="confDatos" style={this.props.styles.styTableInf} onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                            CONFIRMAR DATOS
                          </Button>
                        }
                        {(a010103!==-1&&datosConfirmados==="SI") &&
                          <Button name="btnUpdDel" id="habCambDatos" style={this.props.styles.styTableInf} onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                            HABILITAR CAMBIAR DATOS
                          </Button>
                        }
                      </p>
                    </div>
                    <div className="column" style={{width: '25%', paddingTop: '0.7em'}}>
                      {(a010104!==-1&&envFraCorreo==="N") &&
                        <Button name="btnUpdDel" id="enviar" style={this.props.styles.styTableInf} onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                          AUTORIZA ENVIAR FACTURA POR CORREO
                        </Button>
                      }
                      {(a010104!==-1&&envFraCorreo==="S") &&
                        <Button name="btnUpdDel" id="noEnviar" style={this.props.styles.styTableInf} onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                          NO AUTORIZA ENVIAR FACTURA POR CORREO
                        </Button>
                      }
                    </div>
                  </div>
                </div>
              }>
                <Header icon='edit' color='red' content={confDatos_EnvCorreo==="confDatos"?`Confirmar datos básicos (Teléfono 1, Correo, Fecha de cumpleaños)`:confDatos_EnvCorreo==="habCambDatos"?`Habilitar cambio de datos básicos (Teléfono 1, Correo, Fecha de cumpleaños)`:confDatos_EnvCorreo==="enviar"?`Confirmar autoriza ENVIAR FACTURA POR CORREO`:`NO autoriza ENVIAR FACTURA POR CORREO`} />      
                <Modal.Content>
                  <p>Esta usted seguro ?</p>
                </Modal.Content>
                <Modal.Actions>
                  <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                    <Icon dato1="No" name='remove' /> No
                  </Button>
                  <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>this.props.handleConfDatos(ev, confDatos_EnvCorreo)}>
                    <Icon dato1="Si" name='checkmark' /> Si
                  </Button>
                </Modal.Actions>
              </Modal>
            :
              <div>
                <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                  Tel:&nbsp;{telefonos}&nbsp;&nbsp;&nbsp;&nbsp;Correo:&nbsp;{email}&nbsp;&nbsp;&nbsp;&nbsp;Fecha de cumpleaños:&nbsp;{fechaCumple}&nbsp;&nbsp;&nbsp;&nbsp;
                </p>
              </div>
          }

          <hr></hr>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '34%'}}>
                <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                  Tipo cliente:&nbsp;{tipocl}<br/>
                  Grupo af:&nbsp;{grupoaf}
                </p>
              </div>
              <div className="column" style={{width: '66%'}}>
                <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                  Referencia 1:&nbsp;{referencia1}<br/>
                  Referencia 2:&nbsp;{referencia2}
                </p>
              </div>
            </div>
          </div>
          <hr></hr>
          <div className="ui three column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '34%'}}>
                <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                  Fecha creación en sistema:&nbsp;{fechaCreSist}<br/>
                  Fecha primera activación:&nbsp;{fechaPriAct}
                </p>
              </div>
              <div className="column" style={{width: '33%'}}>
                <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                  Fecha última Desconexión:&nbsp;{fechaUltDX}<br/>
                  Fecha última Reconexión:&nbsp;{fecgaUltRX}
                </p>
              </div>
              <div className="column" style={{width: '33%'}}>
                <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                  Fecha último pago:&nbsp;{fechaUltPago}<br/>
                  Valor último pago:&nbsp;{valorUltPago}
                </p>
              </div>
            </div>
          </div>

          {this.props.permiteHistFinanc &&
            <div>
              <hr></hr>
              <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                Historia financiera&nbsp;&nbsp;&nbsp;&nbsp;
              {a01011501!==-1 &&
                // <a name="histFinancieraPdf" className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTabla(ev, argsDocum)}><i className='file pdf outline icon'></i>Pdf</a>
                <Button id="histFinancieraPdf" name="histFinancieraPdf" style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTabla(ev, argsDocum)}>
                  ARCHIVO PDF
                </Button>
              }
              </p>
              <div style={{height: '40em', overflow: 'auto'}}>
                <table name="histFinanciera" id="histFinanciera" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''>Fecha</th>
                      <th className=''>Servicio</th>
                      <th className=''>Concepto</th>
                      <th className=''>Periodo</th>
                      <th className=''>Documento</th>
                      {/* <th className=''>Pagado</th> */}
                      <th className=''>P x P</th>
                      <th className='' style={{background: '#9D081C'}}>Cargo</th>
                      <th className=''>Pago</th>
                      <th className=''>Saldo cli</th>
                    </tr>
                  </thead>
                  <ListaHistFinanc list={this.props.list4}/>
                </table>
              </div>
            </div>
          }
          {this.props.permiteHistPago &&
            <div>
              <hr></hr>
              <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                Historial de pagos&nbsp;&nbsp;&nbsp;&nbsp;
                {(a01012001!==-1&&this.props.permiteHistPago) &&
                  // <a name="histPagosPdf" className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTabla(ev, argsDocum)}><i className='file pdf outline icon'></i>Pdf</a>
                  <Button id="histPagosPdf" name="histPagosPdf" style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTabla(ev, argsDocum)}>
                    ARCHIVO PDF
                  </Button>
                }
              </p>
              <div style={{height: '20em', overflow: 'auto'}}>
                <table name="histPagos" id="histPagos" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''>Fecha</th>
                      <th className=''>Descripción</th>
                      <th className=''># RC/FRA</th>
                      <th className='right aligned'>$ efectivo</th>
                      <th className='right aligned'>$ cheque</th>
                      <th className='right aligned'>$ TC</th>
                      <th className='right aligned'>$ TD</th>
                      <th className='right aligned'>$ transf</th>
                      <th className='right aligned'>$ Total pago</th>
                    </tr>
                  </thead>
                  <ListaPago list={listPago} idPago={idPago} handleClickidListaP={this.handleClickidListaP}
                    movimientos={this.props.list4} idListaP={idListaP} styles={this.props.styles} fechaHoy={fechaHoy}/>
                </table>
              </div>
              <p></p>
              <Modal open={open} size="tiny" style={this.props.styles.modal} trigger={
                // <div>
                //   <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em'}}>
                //     {titPagoDet}&nbsp;&nbsp;&nbsp;&nbsp;
                //     {(a01012005!==-1&&this.props.permiteHistPago&&idListaP.numeroRC&&idListaP.documento!=="ANULADO") &&
                //       <a className='ui large label' style={this.props.styles.styTableInf} onClick={this.handleClickImpr}><i className='file pdf outline icon'></i>Copia recibo de caja</a>
                //     }
                //     &nbsp;&nbsp;&nbsp;&nbsp;
                //     {(a01012010!==-1&&this.props.permiteHistPago&&(idListaP.numeroRC||idListaP.numeroFra)&&
                //         idListaP.documento!=="ANULADO") &&
                //       <a name="btnUpdDel" id="btnUpdDel" className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleQuestionUpdDel(ev)}><i className='undo icon'></i>Anular pago</a>
                //     }
                //     {(a01012010!==-1&&this.props.permiteHistPago&&(idListaP.numeroRC||idListaP.numeroFra)&&
                //         idListaP.documento==="ANULADO") &&
                //       <span style={{color: 'red', fontSize: '1.5em', fontWeight: 'bold', margin: '0em'}}>{'ANULADO'}</span>
                //     }
                //   </p>



                  <div className="ui four column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '16%', top: '0.6em', paddingRight: '0em'}}>
                        <label style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal'}}>{titPagoDet}</label>
                      </div>
                      <div className="column" style={{width: '14%', top: '0.4em', paddingBottom: '0.4em', paddingLeft: '0em', paddingRight: '1em'}}>
                        {(a01012005!==-1&&this.props.permiteHistPago&&idListaP.numeroRC&&idListaP.documento!=="ANULADO") &&
                          <Button className='ui left labeled icon button' style={this.props.styles.styTableInf}
                              onClick={this.handleClickImpr} primary fluid>
                            <i className='file pdf outline icon'></i>
                            Copia Rbo caja
                          </Button>
                        }
                      </div>
                      <div className="column" style={{width: '40%', paddingBottom: '0.4em', paddingLeft: '1em', paddingRight: '0.4em'}}>
                        {(a01012010!==-1&&this.props.permiteHistPago&&(idListaP.numeroRC||idListaP.numeroFra)&&
                            idListaP.documento!=="ANULADO"&&permitirAnular) &&
                          <div className="ui two column stackable grid">
                            <div className="row container">
                              <div className="column" style={{width: '30%', top: '0.4em', paddingLeft: '0em', paddingRight: '0em'}}>      
                                <Button name="btnUpdDel" id="btnrazonap" className='ui left labeled icon button' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleQuestionUpdDel(ev)} primary fluid>
                                  <i className='undo icon'></i>
                                  Anular pago
                                </Button>
                              </div>
                              <div className="column" style={{width: '70%', top: '0.6em', paddingLeft: '0.2em', paddingRight: '0em'}}>      
                                <input style={{color: '#302b63', height: '2.3em', width: '90%', paddingRight: '0em'}} autoComplete="off" name="razonap" id="razonap" placeholder='Razón' onChange={(ev)=>this.handleChange(ev)}/>
                              </div>
                            </div>
                          </div>
                        }
                        {(a01012010!==-1&&this.props.permiteHistPago&&(idListaP.numeroRC||idListaP.numeroFra)&&
                          idListaP.documento==="ANULADO") &&
                          <label style={{color: 'red', fontSize: '1.5em', fontWeight: 'bold', top: '0.6em'}}>ANULADO ={">"} {idListaP.razonap}</label>
                        }
                      </div>

                      <div className="column" style={{width: '30%', paddingBottom: '0.4em', paddingLeft: '0em', paddingRight: '0.4em'}}>
                        {(a01012015!==-1&&this.props.permiteHistPago&&(idListaP.numeroRC||idListaP.numeroFra)&&
                          idListaP.documento!=="ANULADO"&&permitirAnular) &&
                          <div className="ui two column stackable grid">
                            <div className="row container">
                              <div className="column" style={{width: '40%', top: '0.4em', paddingLeft: '0em', paddingRight: '0em'}}>      
                                <Button name="btnUpdDel" id="btnfechaPago" className='ui left labeled icon button' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleQuestionUpdDel(ev)} primary fluid>
                                  <i className='edit icon'></i>
                                  Fecha pago
                                </Button>
                              </div>
                              <div className="column" style={{width: '60%', top: '0.6em', paddingLeft: '0.2em', paddingRight: '0em'}}>      
                                <input style={{...this.props.styles.input, height: '2.3em'}} type='date' name="fechaPago"
                                  id="fechaPago" value={updFechaPago} min={fechaMin} max={fechaHoy} onChange={this.handleChange}/>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }>
                <Header icon='edit' color='red' content={anular_updfechapago==="btnrazonap"?`Anular pago (${idListaP.numeroRC?idListaP.numeroRC:idListaP.numeroFra})`:`Cambiar fecha de pago a ${updFechaPago}`} />      
                <Modal.Content>
                  <p>Esta usted seguro ?</p>
                </Modal.Content>
                <Modal.Actions>
                  <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                    <Icon dato1="No" name='remove' /> No
                  </Button>
                  <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>this.props.handleAnularPago(ev, idListaP, razonap, updFechaPago, anular_updfechapago)}>
                    <Icon dato1="Si" name='checkmark' /> Si
                  </Button>
                </Modal.Actions>
              </Modal>

              {/* {(stImprRC&&imprRCCl&&this.props.permiteHistPago) && */}
              {(imprRCCl&&this.props.permiteHistPago) &&
                <ImprRC listRCCl={listRCCl} empresa={this.props.empresa} stImprRC={stImprRC}/>
              }

              <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className=''>Clase</th>
                    <th className=''>Servicio</th>
                    <th className=''>Descripción servicio</th>
                    <th className=''>Periodo</th>
                    <th className='right aligned'>$ Valor</th>
                  </tr>
                </thead>
                <ListaPagoDet list={listPagoDet}/>
              </table>
            </div>
          }
          {(this.props.permiteHistFact||this.props.permiteNDF||this.props.permiteNCF) &&
            <div>
              <hr></hr>
              <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                {titFactura}&nbsp;&nbsp;&nbsp;&nbsp;
                {(a01012501!==-1&&this.props.permiteHistFact) &&
                  // <a name="histFacturacionPdf" className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTabla(ev, argsDocum)}><i className='file pdf outline icon'></i>Pdf</a>
                  <Button id="histFacturacionPdf" name="histFacturacionPdf" style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTabla(ev, argsDocum)}>
                    ARCHIVO PDF
                  </Button>
                }
              </p>
              <div style={{height: '20em', overflow: 'auto'}}>
                <table name="histFacturacion" id="histFacturacion" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''># Factura</th>
                      <th className=''>Fecha</th>
                      <th className=''>Año</th>
                      <th className=''>mes</th>
                      <th className='right aligned'>$ antes de imptos</th>
                      <th className='right aligned'>$ despues de imptos</th>
                      <th className='right aligned'>$ Total Factura</th>
                    </tr>
                  </thead>
                  <ListaFact list={listFact} handleClickidListaF={this.handleClickidListaF}
                      idListaF={idListaF} styles={this.props.styles}/>
                </table>
              </div>
              <p></p>

              <div className="ui two column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '80%'}}>
                    {(this.props.empresaArchFE!=="conectic"&&this.props.empresaArchFE!=="supercable"&&this.props.empresaArchFE!=="supercablebq") &&
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        <br></br>
                        {titFacturaDet}&nbsp;&nbsp;&nbsp;&nbsp;
                        {(a01012505!==-1&&this.props.permiteHistFact&&idListaF.codProcFact!=="ANULADA") &&
                          <a className='ui large label' style={this.props.styles.styTableInf} onClick={this.handleClickImpr}><i className='file pdf outline icon'></i>{labelCopiaFra}</a>
                        }
                        {(a01012505!==-1&&this.props.permiteHistFact&&idListaF.codProcFact==="ANULADA") &&
                          <span style={{color: 'red', fontSize: '1.5em', fontWeight: 'bold', margin: '0em'}}>{'ANULADA'}</span>
                        }
                      </p>
                    }
                    {(this.props.empresaArchFE==="conectic"||this.props.empresaArchFE==="supercable"||this.props.empresaArchFE==="supercablebq") &&
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        <br></br>
                        <Modal open={open} size="tiny" style={this.props.styles.modal} trigger={
                          <div>
                            {titFacturaDet}&nbsp;&nbsp;&nbsp;&nbsp;
                            {(a01012505!==-1&&this.props.permiteHistFact&&idListaF.codProcFact!=="ANULADA") &&
                              <a name="factMod1" className='ui large label' style={this.props.styles.styTableInf} onClick={this.handleClickImpr}><i className='file pdf outline icon'></i>{labelCopiaFra}</a>                    
                            }
                            {(a01012505!==-1&&this.props.permiteHistFact&&idListaF.codProcFact!=="ANULADA") &&
                              <a name="factMod2" className='ui large label' style={this.props.styles.styTableInf} onClick={this.handleClickImpr}><i className='file pdf outline icon'></i>Copia factura modelo 2</a>                    
                            }

                            {(a01012505!==-1&&(this.props.empresaArchFE==="conectic"||this.props.empresaArchFE==="supercable")&&this.props.permiteHistFact&&idListaF.tipoGen==="proceso"&&idListaF.codProcFact!=="ANULADA") &&
                              <a name="btnUpdDel" id="factECMod2" className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleQuestionUpdDel(ev)}><i className='file pdf outline icon'></i>Enviar correo fra modelo 2</a>                    
                            }
                          </div>
                        }>
                          <Header icon='edit' color='red' content={`Enviar factura ${idListaF.numeroFra} al correo ${this.props.idLista.eMail}`} />      
                          <Modal.Content>
                            <p>Esta usted seguro ?</p>
                          </Modal.Content>
                          <Modal.Actions>
                            <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                              <Icon dato1="No" name='remove' /> No
                            </Button>
                            <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>this.props.handleEnvCorreo(ev, idListaF, this.props.empresa, this.props.allRangoFact.allRangoFact)}>
                              <Icon dato1="Si" name='checkmark' /> Si
                            </Button>
                          </Modal.Actions>
                        </Modal>
                        {(a01012505!==-1&&this.props.permiteHistFact&&idListaF.codProcFact==="ANULADA") &&
                          <span style={{color: 'red', fontSize: '1.5em', fontWeight: 'bold', margin: '0em'}}>{'ANULADA'}</span>
                        }
                      </p>
                    }
                    {/* {(stImprFact&&imprFactCl&&this.props.permiteHistFact) && */}
                    {(imprFactCl&&this.props.permiteHistFact) &&
                      <ImprFact listFactCl={listFactCl} list2={this.props.allProcFact.allProcFact}
                                list={this.props.allRangoFact.allRangoFact} empresa={this.props.empresa}
                                stImprFact={stImprFact}/>
                    }
                  </div>
                  {!this.props.permiteHistFact &&
                    <div className="column" style={{width: '40%'}}>
                      <p>
                        <span style={{background: '#7F7FD5', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                          {titTotN}: &nbsp;&nbsp;
                          <span style={{color: '#302b63', fontSize: '2em'}}> ${totNota}</span>
                        </span>
                      </p>
                    </div>
                  }
                </div>
              </div>


              {this.props.permiteHistFact &&
                <div>
                  <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Clase</th>
                        <th className=''>Servicio</th>
                        <th className=''>Descripción servicio</th>
                        <th className=''>Concepto</th>
                        <th className='right aligned'>$ Valor</th>
                      </tr>
                    </thead>
                    <ListaFactDet list={listFactDet}/>
                  </table>
                </div>
              }

                  {!this.props.permiteHistFact &&
                    <div>
                      <Form name="form3" id="form3" onSubmit={confirmaAct?(ev)=>this.props.handleSubmitNot(ev, listFactDetN, totNota, idListaF, argsDocum, lista4, stObservacNota):()=>{}}>
                        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                          <thead className=''>
                            <tr className=''>
                              <th className=''>Clase</th>
                              <th className=''>Descripción servicio</th>
                              <th className=''>$ antes de imptos</th>
                              <th className='center aligned'>$ Impuestos</th>
                              <th className='center aligned'>$ Nota</th>
                            </tr>
                          </thead>
                          <ListaFactDetN styles={this.props.styles} list={listFactDetN} handleChangeDetFN={this.handleChangeDetFN}/>
                        </table>
                        <p></p>
                        <Form.Field>
                          <label style={{color: '#302b63', fontSize: '1em', fontWeight: 'bold'}}>Observaciones</label>
                          <input style={this.props.styles.input} autoComplete="off" name="observacNota" id="observacNota" value={stObservacNota} onChange={(ev)=>this.handleChangeDetFN(ev)} placeholder='Observaciones' />
                        </Form.Field>

                        <hr></hr>

                        <EstaSegGral btnText='Hacer Nota' open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>

                        {
                          this.props.errors.length?<Message negative header="Los siguientes errores:"
                          list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                        }
                    </Form>
                  </div>
                }
            </div>
          }


          {(this.props.permiteHistNot) &&
            <div>
              <hr></hr>
              <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                {titNot}&nbsp;&nbsp;
                {(a01013501!==-1&&this.props.permiteHistNot) &&
                  // <a name="histNotPdf" className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTabla(ev, argsDocum)}><i className='file pdf outline icon'></i>Pdf</a>
                  <Button id="histNotPdf" name="histNotPdf" style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTabla(ev, argsDocum)}>
                    ARCHIVO PDF
                  </Button>
                }
              </p>

              <table name="histNot" id="histNot" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className=''># Nota</th>
                    <th className=''>Tipo</th>
                    <th className=''>Fecha</th>
                    <th className=''># Factura</th>
                    <th className=''>Creada por</th>
                    <th className='right aligned'>$ antes de imptos</th>
                    <th className='right aligned'>$ Total Nota</th>
                  </tr>
                </thead>
                <ListaNot list={listNot} handleClickidListaNot={this.handleClickidListaNot}/>
              </table>
              <p></p>

              <div className="ui two column stackable grid">
                <div className="row container">
                <div className="column" style={{width: '55%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    <br></br>
                    {titNotDet}
                  </p>
                </div>
                {!this.props.permiteHistNot &&
                  <div className="column" style={{width: '45%'}}>
                    <p>
                      <span style={{background: '#7F7FD5', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                        {titTotN}: &nbsp;&nbsp;
                        <span style={{color: '#302b63', fontSize: '2em'}}> ${totNota}</span>
                      </span>
                    </p>
                  </div>
                  }
                </div>
              </div>
              {this.props.permiteHistNot &&
                <div>
                  <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Clase</th>
                        <th className=''>Servicio</th>
                        <th className=''>Descripción servicio</th>
                        <th className=''>Concepto</th>
                        <th className='right aligned'>$ Valor</th>
                      </tr>
                    </thead>
                    <ListaNotDet list={listNotDet}/>
                  </table>
                </div>
              }
            </div>
          }

          {(this.props.permiteHistAj) &&
            <div>
              <hr></hr>
              <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                {titAj}&nbsp;&nbsp;
                {(a01013501!==-1&&this.props.permiteHistAj) &&
                  // <a name="histAjPdf" className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTabla(ev, argsDocum)}><i className='file pdf outline icon'></i>Pdf</a>
                  <Button id="histAjPdf" name="histAjPdf" style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTabla(ev, argsDocum)}>
                    ARCHIVO PDF
                  </Button>                
                }
              </p>

              <table name="histAj" id="histAj" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className=''># Ajuste</th>
                    <th className=''>Tipo</th>
                    <th className=''>Fecha</th>
                    <th className=''>Creado por</th>
                    <th className=''>Concepto</th>
                    <th className='right aligned'>$ Ajuste</th>
                  </tr>
                </thead>
                <ListaAj list={listAj}/>
              </table>
            </div>
          }

          {(this.props.permiteAjP||this.props.permiteAjN||this.props.permiteNCA||this.props.permiteNCPF||this.props.permiteProgNvoServ) &&
            <div>
              <hr></hr>
              <div className="ui two column stackable grid">
                  <div className="row container">
                  <div className="column" style={{width: '45%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    <br></br>
                    {titTipoAjNota}
                  </p>
                    </div>
                  </div>
                </div>
              <div>
              <Form name="form2" id="form2" onSubmit={confirmaAct
                ?
                  (this.props.permiteAjP||this.props.permiteAjN)
                  ?
                    (ev)=>this.props.handleSubmitAju(ev, stConcepto, stValor, argsDocum, lista4)
                  :
                    (this.props.permiteAjP||this.props.permiteNCA)
                    ?
                      (ev)=>this.props.handleSubmitNotAut(ev, stConcepto, stValor, argsDocum, lista4)
                    :
                      (this.props.permiteAjP||this.props.permiteNCPF)
                      ?
                        (ev)=>this.props.handleSubmitNvoCargoPF(ev, stValor, argsDocum)
                      :
                        (ev)=>this.props.handleSubmitProgServ(ev, argsDocum, (this.props.permiteProgNvoServ&&listaPS.length===0)?"Crear":"Eliminar")
                :
                  ()=>{}}
                >
                <div className='ui blue inverted raised segment'>
                  <Form.Field>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        {/* <div className="column" style={{width: '70%'}}> */}
                        <div className="column" style={{ width: (this.props.permiteProgNvoServ&&listaPS.length>0) ? '100%' : '70%' }}>
                          {(!this.props.permiteNCPF&&!this.props.permiteProgNvoServ) &&
                            <div>
                              <label style={this.props.styles.label}>Concepto</label>
                              <input style={this.props.styles.input} autoComplete="off" name="concepto" id="concepto" value={stConcepto} onChange={(ev)=>this.handleChange(ev)} placeholder='Concepto' />
                            </div>
                          }
                          {this.props.permiteNCPF &&
                            <div>
                              <label style={this.props.styles.label}>Concepto del nuevo cargo a próxima factura</label>
                              <ListaCpto list={cptosOP} styles={this.props.styles} handleCpto={this.handleCpto}/>
                            </div>
                          }
                          {(this.props.permiteProgNvoServ&&listaPS.length>0) &&
                            <p style={{color: 'red', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Tiene programado el Servicio: {listaPS[0].nombreResumido} {"=>"} {listaPS[0].descripcionServicio} {"=>"} {general.formatNum(listaPS[0].valorTotal.toString())} {"=>"} {listaPS[0].fechaProg.substr(0, 10)}
                            </p>
                          }
                          {(this.props.permiteProgNvoServ&&listaPS.length===0&&estadoCliente!=='ACTIVO') &&
                            <p style={{color: 'red', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              El cliente debe estar ACTIVO
                            </p>
                          }
                          {(this.props.permiteProgNvoServ&&listaPS.length===0&&estadoCliente==='ACTIVO') &&
                            <div>
                              <label style={this.props.styles.label}>Servicio a programar</label>
                              <ListaServPS list={servTar} styles={this.props.styles} handleServProg={this.handleServProg}/>
                            </div>
                          }
                        </div>
                        {(this.props.permiteProgNvoServ&&listaPS.length===0&&estadoCliente==='ACTIVO') &&
                          <div className="column" style={{width: '30%'}}>
                            <label style={this.props.styles.label}>Programar en la fecha</label>
                            <input style={{...this.props.styles.input}} type='date' name="fechaPS"
                              id="fechaPS" value={updFechaPS} min={fechaMinPS} onChange={this.handleChange}/>
                          </div>
                        }
                        {!this.props.permiteProgNvoServ &&
                          <div className="column" style={{width: '30%'}}>
                            <label style={this.props.styles.label}>Valor</label>
                            <input type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="valor" id="valor" value={stValor} placeholder='Valor' onChange={(ev)=>this.handleChange(ev)}/>
                          </div>
                        }
                      </div>
                    </div>
                  </Form.Field>
                </div>
                <hr></hr>

                {(!this.props.permiteProgNvoServ||
                  (this.props.permiteProgNvoServ&&estadoCliente==='ACTIVO')||
                  (this.props.permiteProgNvoServ&&listaPS.length>0)) &&
                  <EstaSegGral 
                    btnText={(this.props.permiteProgNvoServ&&listaPS.length>0) ? 'Eliminar Servicio Programado' : 'Hacer ' + titTipoAjNota} 
                    open={open} 
                    styles={this.props.styles} 
                    handleQuestionUpdDel={this.handleQuestionUpdDel}
                  />
                }

                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
                </Form>
              </div>
            </div>
          }

          {this.props.permiteMNF &&
            <div>
              <hr></hr>
              <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                {titMNF}
              </p>
              <Form name="formMNF" id="formMNF" onSubmit={confirmaAct?(ev)=>this.handleSubmitMNF(ev, argsDocumMNF, listaMNF):()=>{}}>
                <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className=''>Año</th>
                      <th className=''>Mes</th>
                      <th className=''>Observaciones</th>
                      <th className=''>Procesado</th>
                      <th className=''>Fecha agregado</th>
                      <th className=''>Agregado por</th>
                      <th className=''>Eliminar</th>
                    </tr>
                  </thead>
                  <ListaMNF list={listaMNF} handleElimMNF={this.handleElimMNF} permiteMNF={this.props.permiteMNF}/>
                </table>
                <hr></hr>
                <p></p>
                <Form.Field>
                  <div className="ui three column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '20%'}}>
                        <label style={{color: '#302b63', fontSize: '1em', fontWeight: 'bold'}}>Año</label>
                        <ListaAgno list={listaAgno} styles={this.props.styles} handleAgno={this.handleAgno}/>
                      </div>
                      <div className="column" style={{width: '20%'}}>
                        <label style={{color: '#302b63', fontSize: '1em', fontWeight: 'bold'}}>Mes</label>
                        <ListaMes list={listaMes} styles={this.props.styles} handleMes={this.handleMes}/>
                      </div>
                      <div className="column" style={{width: '60%'}}>
                        <label style={{color: '#302b63', fontSize: '1em', fontWeight: 'bold'}}>Observaciones</label>
                        <input style={this.props.styles.input} autoComplete="off" name="observacMNF" id="observacMNF" value={argsDocumMNF.observaciones} onChange={(ev)=>this.handleChangeDetFN(ev)} placeholder='Observaciones' />
                      </div>
                    </div>
                  </div>
                </Form.Field>

                <hr></hr>
                <EstaSegGral btnText='AGREGAR MES que NO se le va a facturar' open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>

                {
                  errorAdd.length?<Message negative header="Los siguientes errores:"
                  list={errorAdd.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </Form>
            </div>
          }

          {/* CAMBIAR DIRECCION */}
          {this.props.permiteUpdateDir &&
            <div>
              <Divider inverted />
              <div style={this.props.styles.box}>
                <Form name="form4" id="form4" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, this.props.args, "", argsSelDpto, "", "", "", argsDocum):()=>{}}>
                  {/* <a className='ui large label' style={this.props.styles.styTableInf}>Cambiar dirección</a>
                  <a className='ui large label' style={this.props.styles.styTableInf}><i className='delete center icon' onClick={this.props.handleCerrarWin}/></a>
                  <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableInf}>
                    <ListaDirAct linea1={linea1DNN} linea2={linea2DNN} linea3={linea3DNN} linea4={linea4DNN}/>
                  </table> */}
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={this.props.styles.boxGrid}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Vía principal</label>
                          <Lista seleccLista="descrTipoVia1" list={list2} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                          <input style={this.props.styles.input} autoComplete="off" name="numeroTipoVia1" id="numeroTipoVia1" onChange={this.props.handleChange} placeholder='Número'/>
                        </Form.Field>
                        <Form.Field>
                          <label style={this.props.styles.label}>Vía secundaria</label>
                          <Lista seleccLista="descrTipoVia2" list={list2} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                          <input style={this.props.styles.input} autoComplete="off" name="numeroTipoVia2" id="numeroTipoVia2" onChange={this.props.handleChange} placeholder='Número'/>
                            <input style={this.props.styles.input} autoComplete="off" name="numeroTipoVia2F" id="numeroTipoVia2F" onChange={this.props.handleChange} placeholder='Número'/>
                        </Form.Field>
                        <Form.Field>
                          <label style={this.props.styles.label}>Tipo de unidad 1</label>
                          <Lista seleccLista="descrTipoUnd1" list={list3} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                          <input style={this.props.styles.input} autoComplete="off" name="numeroTipoUnd1" id="numeroTipoUnd1" onChange={this.props.handleChange} placeholder='Número'/>
                        </Form.Field>
                        <Form.Field>
                          <label style={this.props.styles.label}>Tipo de unidad 2</label>
                          <Lista seleccLista="descrTipoUnd2" list={list3} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                          <input style={this.props.styles.input} autoComplete="off" name="numeroTipoUnd2" id="numeroTipoUnd2" onChange={this.props.handleChange} placeholder='Número'/>
                        </Form.Field>
                      </div>
                      <div className="column" style={this.props.styles.boxGrid}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Unidad matriz</label>
                          <Lista seleccLista="descrTiUndMat" list={list4} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                          <Lista seleccLista="descrUndMat" list={list5} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                        </Form.Field>
                        <Form.Field>
                          <label style={this.props.styles.label}>Departamento</label>
                          <ListaDe list={list1} styles={this.props.styles} handleCiudadDpto={this.handleCiudadDpto}
                            codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}/>
                        </Form.Field>
                        <Form.Field>
                          <label style={this.props.styles.label}>Ciudad</label>
                          <ListaCi list={list1} styles={this.props.styles} handleZonaCiudad={this.handleZonaCiudad}
                            argsSelDpto={argsSelDpto} codigoCiudadUA={this.props.codigoCiudadUA}/>
                        </Form.Field>
                        <Form.Field>
                          <label style={this.props.styles.label}>Barrio</label>
                          <ListaBa list={list1} styles={this.props.styles} handleBarrioSel={this.handleBarrioSel} argsSelDpto={argsSelDpto}/>
                        </Form.Field>
                        <Form.Field>
                          <label style={this.props.styles.label}>Zona</label>
                          <ListaZo styles={this.props.styles} argsSelDpto={argsSelDpto}/>
                        </Form.Field>

                        {this.props.empresa.empresaArchFE==="codisert" &&
                          <Form.Field>
                            <label style={this.props.styles.label}>Estrato</label>
                            <Lista seleccLista="descrEstrato" list={list3Estr} styles={this.props.styles} handleLista4={this.props.handleLista4}/>
                          </Form.Field>
                        }
                      </div>
                    </div>
                  </div>
                  <hr></hr>

                  <EstaSeguro permiteUpdate={this.props.permiteUpdateDir} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>

                  {
                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                </Form>
              </div>
            </div>          
          }

          {(this.props.permiteUpdate||this.props.permiteDelete) &&
            <div>
              <hr></hr>
              <div style={this.props.styles.box}>
                <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum, this.props.comoAsigCicloFact,
                                                        "", "", "", "", "", this.props.modeloFactura, this.props.empresaArchFE):()=>{}}>
                    <div className="ui two column stackable grid">
                        <div className="row container">
                            <div className="column" style={this.props.styles.boxGrid}>
                              {(argsDocum.codigoTipoDoc==="NIT"&&argsDocum.descrTipoDoc!==undefined&&argsDocum.descrTipoDoc!=="Seleccionar...") &&
                                <label style={{
                                  ...this.props.styles.label,
                                  color: "#82e256", textAlign: "center", fontSize: "24px", display: "block"
                                }}>EMPRESA</label>
                              }
                              {(argsDocum.codigoTipoDoc!=="NIT"&&argsDocum.descrTipoDoc!==undefined&&argsDocum.descrTipoDoc!=="Seleccionar...") &&
                                <label style={{
                                  ...this.props.styles.label,
                                  color: "#82e256", textAlign: "center", fontSize: "24px", display: "block"
                                }}>PERSONA</label>
                              }

                              <Form.Field>
                                <label style={this.props.styles.label}>Contrato</label>
                                <input style={this.props.styles.input} autoComplete="off" name="contrato" id="contrato" value={argsDocum.contrato} onChange={this.handleChange} placeholder='Contrato' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'contrato'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                              </Form.Field>

                                <Form.Field>
                                    <label style={this.props.styles.label}>Nombre</label>
                                    <input style={this.props.styles.input} autoComplete="off" name="nombreCliente" id="nombreCliente" value={this.props.permiteUpdate?argsDocum.nombreCliente:this.props.idLista.nombreCliente} onChange={this.handleChange} placeholder='Nombre' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'nombreCliente'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={this.props.styles.label}>Apellido(s)</label>
                                    <input style={this.props.styles.input} autoComplete="off" name="apellidoCliente" id="apellidoCliente" value={this.props.permiteUpdate?argsDocum.apellidoCliente:this.props.idLista.apellidoCliente} onChange={this.handleChange} placeholder='Apellido(s)' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'apellidoCliente'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                  <div className="ui two column stackable grid">
                                    <div className="column" style={{width: '50%'}}>
                                      <label style={this.props.styles.label}>Estrato</label>
                                      <ListaES list={this.props.list3} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                                    </div>
                                    {this.props.listSeg.length>1 &&
                                      <div className="column" style={{width: '50%'}}>
                                        <label style={this.props.styles.label}>Segmento</label>
                                        <ListaSeg list={this.props.listSeg} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                                      </div>
                                    }
                                    {/* {this.props.comoAsigCicloFact==="Asignarlo al crear o modificar clientes" &&
                                    <div className="column" style={{width: '50%'}}>
                                      <label style={this.props.styles.label}>Ciclo de facturación</label>
                                      <ListaCF list={this.props.list8} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                                    </div>
                                    } */}
                                  </div>
                                </Form.Field>
                                <Form.Field>
                                    <label style={this.props.styles.label}>Sexo</label>
                                    <Form.Checkbox className="ui radio checkbox" style={this.props.styles.chekBox}
                                        radio label='Masculino' name='sexoCliente' value='Masculino'
                                        checked={this.state.valchkbox === 'Masculino'} onChange={this.handleChange}
                                    />
                                    <Form.Checkbox className="ui radio checkbox" style={this.props.styles.chekBox}
                                        radio label='Femenino' name='sexoCliente' value='Femenino'
                                        checked={this.state.valchkbox === 'Femenino'} onChange={this.handleChange}
                                    />
                                </Form.Field>

                                <Form.Field>
                                  <label style={this.props.styles.label}>Documento de identidad</label>
                                  <div className="ui two column stackable grid">
                                    <div className="column" style={{width: '60%'}}>
                                      <ListaTD list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                                    </div>
                                    <div className="column" style={{width: '40%'}}>
                                      <input style={this.props.styles.input} style={this.props.styles.input} pattern={
                                        argsDocum.codigoTipoDoc === "NIT"
                                          ? "[0-9]{5,10}-[0-9]"
                                          : "[0-9]{5,10}[0-9\\-]{0,1}[0-9]{0,1}"
                                      } autoComplete="off" name="numeroDoc" id="numeroDoc" value={this.props.permiteUpdate?argsDocum.numeroDoc:this.props.idLista.numeroDoc} onChange={this.handleChange} placeholder='Número del documento' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'numeroDoc'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                    </div>
                                  </div>
                                </Form.Field>

                              <Form.Field>
                                <label style={this.props.styles.label}>Tipo de cliente</label>
                                <ListaTC list={this.props.listaTC1} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                              </Form.Field>
                              <Form.Field>
                                <label style={this.props.styles.label}>Grupo de afinidad</label>
                                <ListaGA list={this.props.list2} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                              </Form.Field>
                            </div>
                            <div className="column" style={this.props.styles.boxGrid}>
                              <Form.Field>
                                <label style={this.props.styles.label}>Teléfonos de contacto</label>
                                <input style={this.props.styles.input} pattern={"[0-9]{7,10}"} autoComplete="off" name="telefono1" id="telefono1" value={this.props.permiteUpdate?argsDocum.telefono1:!this.props.idLista.telefono1?'':this.props.idLista.telefono1} onChange={this.handleChange} placeholder='Teléfono 1' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefono1'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                <input style={this.props.styles.input} pattern={"[0-9]{7,10}"} autoComplete="off" name="telefono2" id="telefono2" value={this.props.permiteUpdate?argsDocum.telefono2:!this.props.idLista.telefono2?'':this.props.idLista.telefono2} onChange={this.handleChange} placeholder='Teléfono 2' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefono2'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                <input style={this.props.styles.input} pattern={"[0-9]{7,10}"} autoComplete="off" name="telefono3" id="telefono3" value={this.props.permiteUpdate?argsDocum.telefono3:!this.props.idLista.telefono3?'':this.props.idLista.telefono3} onChange={this.handleChange} placeholder='Teléfono 3' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefono3'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                              </Form.Field>
                              <Form.Field>
                                <label style={this.props.styles.label}>Correo electrónico</label>
                                <input style={this.props.styles.input} pattern={"[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\.[a-z]{0,}$"} autoComplete="off" name="eMail" id="eMail" value={this.props.permiteUpdate?argsDocum.eMail:!this.props.idLista.eMail?'':this.props.idLista.eMail} onChange={this.handleChange} placeholder='Correo electrónico' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'eMail'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                              </Form.Field>

                              <Form.Field>
                                <label style={this.props.styles.label}>Fecha de cumpleaños</label>
                                <input style={this.props.styles.input} type='date' name="fechaCumple" id="fechaCumple" value={this.props.permiteUpdate?argsDocum.fechaCumple:!this.props.idLista.fechaCumple?'':this.props.idLista.fechaCumple.substr(0, 10)} onChange={this.handleChange}/>
                              </Form.Field>

                              <Form.Field>
                                <label style={this.props.styles.label}>Referencia 1 ={">"} Nombre y teléfono</label>
                                <input style={this.props.styles.input} autoComplete="off" name="referencia1" id="referencia1" value={this.props.permiteUpdate?argsDocum.referencia1:!this.props.idLista.referencia1?'':this.props.idLista.referencia1} onChange={this.handleChange} placeholder='Nombre referencia 1' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'referencia1'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                <input style={this.props.styles.input} autoComplete="off" name="telefonoRef1" id="telefonoRef1" value={this.props.permiteUpdate?argsDocum.telefonoRef1:!this.props.idLista.telefonoRef1?'':this.props.idLista.telefonoRef1} onChange={this.handleChange} placeholder='Teléfono referencia 1' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefonoRef1'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                              </Form.Field>
                              <Form.Field>
                                <label style={this.props.styles.label}>Referencia 2 ={">"} Nombre y teléfono</label>
                                <input style={this.props.styles.input} autoComplete="off" name="referencia2" id="referencia2" value={this.props.permiteUpdate?argsDocum.referencia2:!this.props.idLista.referencia2?'':this.props.idLista.referencia2} onChange={this.handleChange} placeholder='Nombre referencia 2' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'referencia2'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                <input style={this.props.styles.input} autoComplete="off" name="telefonoRef2" id="telefonoRef2" value={this.props.permiteUpdate?argsDocum.telefonoRef2:!this.props.idLista.telefonoRef2?'':this.props.idLista.telefonoRef2} onChange={this.handleChange} placeholder='Teléfono referencia 2' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telefonoRef2'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                              </Form.Field>

                              <Form.Field>
                                <label style={this.props.styles.label}>Observaciones</label>
                                <input style={this.props.styles.input} autoComplete="off" name="observaciones" id="observaciones" value={this.props.permiteUpdate?argsDocum.observaciones:!this.props.idLista.observaciones?'':this.props.idLista.observaciones} onChange={this.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observaciones'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                              </Form.Field>
                              {this.props.empresaArchFE==="conectic" &&
                                <Form.Field>
                                  <label style={this.props.styles.label}>Información adicional</label>
                                  <ListaInfAdic styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                                </Form.Field>
                              }
                              {(this.props.modeloFactura!=="1"&&this.props.empresaArchFE!=="conectic") &&
                                <Form.Field>
                                  <label style={this.props.styles.label}>Información adicional</label>
                                  <input style={this.props.styles.input} autoComplete="off" name="infAdic1" id="infAdic1" value={this.props.permiteUpdate?argsDocum.infAdic1:this.props.idLista.infAdic1?this.props.idLista.infAdic1:""} onChange={this.handleChange} placeholder='Información adicional' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'infAdic1'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                              }

                            </div>                        
                        </div>
                    </div>
                    <hr></hr>

                    <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    {
                      this.props.errors.length?<Message negative header="Los siguientes errores:"
                      list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                    }

                  </Form>
                </div>
              </div>
            }

            {(!this.props.permiteUpdate&&!this.props.permiteUpdateDir&&!this.props.permiteDelete&&
              !this.props.permiteHistFinanc&&
              !this.props.permiteHistPago&&!this.props.permiteHistFact&&
              !this.props.permiteHistNot&&!this.props.permiteHistAj&&
              !this.props.permiteNDF&&!this.props.permiteNCF&&!this.props.permiteNCA&&!this.props.permiteNCPF&&
              !this.props.permiteProgNvoServ&&
              !this.props.permiteAjP&&!this.props.permiteAjN&&!this.props.permiteMNF) &&
                <div>

                  {/* {(a010111!==-1&&latitud!==0&&longitud!==0) &&
                    <div>
                      <hr></hr>
                      <Mapa latitud={latitud} longitud={longitud} keyMaps={keyMaps}/>
                    </div>
                  } */}

                    {listServTarAct.length>0 &&
                      <div>
                        <hr></hr>
                        <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Tarifa
                        </p>
                        <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em'}}>
                          {tarifaAct}
                        </p>
                        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                          <thead className=''>
                            <tr className=''>
                              <th className=''>Estado</th>
                              <th className=''>Clase</th>
                              <th className=''>Servicio</th>
                              <th className=''>Descripción servicio</th>
                              <th className='center aligned'># serv</th>
                              <th className='center aligned'>Valor serv</th>
                            </tr>
                          </thead>
                          <ListaServTar styles={this.props.styles} list={listServTarAct} permAct=''/>
                        </table>
                        {listaPS.length>0 &&
                          <p style={{color: 'red', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                            Tiene programado el Servicio: {listaPS[0].nombreResumido} {"=>"} {listaPS[0].descripcionServicio} {"=>"} {general.formatNum(listaPS[0].valorTotal.toString())} {"=>"} {listaPS[0].fechaProg.substr(0, 10)}
                          </p>
                        }
                      </div>
                    }
                    {listServOfAct.length>0 &&
                      <div>
                        <hr></hr>
                        <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Oferta
                        </p>
                        <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0em'}}>
                          {ofertaAct}
                        </p>
                        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                          <thead className=''>
                            <tr className=''>
                              <th className=''></th>
                              <th className=''>Clase</th>
                              <th className=''>Servicio</th>
                              <th className=''>Descripción servicio</th>
                              <th className='center aligned'>% Dcto</th>
                              <th className='center aligned'>Días oferta</th>
                              <th className=''>Fin oferta</th>
                            </tr>
                          </thead>
                          <ListaServOf list={listServOfAct}/>
                        </table>
                      </div>
                    }
                    {listEquiCliAct.length>0 &&
                      <div>
                        <hr></hr>
                        <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Equipos
                        </p>
                        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                          <thead className=''>
                            <tr className=''>
                              <th className=''>Serial</th>
                              <th className=''>Mac</th>
                              <th className=''>Clase</th>
                              <th className=''>Marca</th>
                              <th className=''>Fabricante</th>
                            </tr>
                          </thead>
                          <ListaEquiCli list={listEquiCliAct}/>
                        </table>
                      </div>
                    }
                    {listaMNF.length>0 &&
                      <div>
                        <hr></hr>
                        <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          NO facturar Meses
                        </p>
                        <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                          <thead className=''>
                            <tr className=''>
                              <th className=''>Año</th>
                              <th className=''>Mes</th>
                              <th className=''>Observaciones</th>
                              <th className=''>Procesado</th>
                              <th className=''>Fecha agregado</th>
                              <th className=''>Agregado por</th>
                            </tr>
                          </thead>
                          <ListaMNF list={listaMNF} handleElimMNF={this.handleElimMNF} permiteMNF={this.props.permiteMNF}/>
                        </table>
                      </div>
                    }   
                    {(listMovCCCli.length>0&&((a010112!==-1&&this.props.empresa.empresaArchFE==="codisert")||this.props.empresa.empresaArchFE!=="codisert")) &&
                      <div>
                        <hr></hr>
                        <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Cargos adicionales
                        </p>
                        <div style={listMovCCCli.length>10?{height: '40em', overflow: 'auto'}:{height: '20em', overflow: 'auto'}}>
                          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                            <thead className=''>
                              <tr className=''>
                                <th className=''>Fecha</th>
                                <th className=''>Servicio</th>
                                <th className=''>Periodo</th>
                                <th className=''>Origen</th>
                                <th className=''>Valor</th>
                                <th className=''># Factura</th>
                                <th className=''>fecha NO FACT</th>
                                <th className=''>Usuario NO FACT</th>
                                <th className=''>Usuario Creó</th>
                              </tr>
                            </thead>
                            <ListaMovCCCli list={listMovCCCli}/>
                          </table>
                        </div>
                      </div>
                    }
                    {(listHistCli.length>0&&((a010112!==-1&&this.props.empresa.empresaArchFE==="codisert")||this.props.empresa.empresaArchFE!=="codisert")) &&
                      <div>
                        <hr></hr>
                        <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Historia del cliente
                        </p>
                        <div style={{height: '40em', overflow: 'auto'}}>
                          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                            <thead className=''>
                              <tr className=''>
                                <th className=''>Fecha</th>
                                <th className=''>Movim</th>
                                <th className='center aligned'>#</th>
                                <th className=''>Descripción</th>
                                <th className=''>Detalle</th>
                                <th className='center aligned'>Valor</th>
                                <th className=''>Usuario</th>
                              </tr>
                            </thead>
                            <ListaHistCli list={listHistCli}/>
                          </table>
                        </div>
                      </div>
                    }
                  </div>
            }
                    </div>
                </div>
                </div>

        </div>
    )
  }
}

export default compose(
  // Para programar nuevo servicio
  graphql(queries.query.allTarifa, {name:'allTarifa', options: (props) => {return {variables: {codigoTarifa: props.idLista.tarifa.codigoTarifa}}}}),

  graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allHistCliente, {name:'allHistCliente', options: (props) => {return {variables: {contrato: props.idLista.contrato, orden: '-_id'}}}}),

  graphql(queries.mutation.createNotasDebCre, {name:'createNotasDebCre'}),
  graphql(queries.mutation.editNotasDebCreUpdDoc, {name:'editNotasDebCreUpdDoc'}),
  // graphql(queries.mutation.createMovClientes, {name:'createMovClientes'}),
  graphql(queries.mutation.editCliente, {name:'editCliente'}),
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
  // graphql(queries.mutation.editPagoClientes, {name:'editPagoClientes'}),

  graphql(queries.query.allFactRtesGroup, {name:'allFactRtesGroup', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: '123XYZ'}}]`}}}}),
  // graphql(queries.query.allMovRtesCC, {name:'allMovRtesCC',options: (props) =>
  //   {return {variables: {tipoqry: `[{$match: {procesado: "N", contrato: "${props.idLista.contrato}"}},{$sort: {contrato: 1, fechaMov: 1}}]`}}}}),
  graphql(queries.query.allMovRtesCC, {name:'allMovRtesCC',options: (props) =>
    {return {variables: {tipoqry: `[{$match: {valorTotal: {$ne: 0}, contrato: "${props.idLista.contrato}"}},{$sort: {contrato: 1, procesado: 1, _id: -1}}]`}}}}),

  graphql(queries.query.allRangoFact, {name:'allRangoFact', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allProcFact, {name:'allProcFact', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allTiUndMat, {name:'allTiUndMat'}),
  graphql(queries.query.allTipoUnd, {name:'allTipoUnd'}),
  graphql(queries.query.allTipoVia, {name:'allTipoVia'}),
  graphql(queries.query.allUndMat, {name:'allUndMat', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allMesNoFra, {name:'allMesNoFra', options: (props) => {return {variables: {contrato: props.idLista.contrato}}}}),
  graphql(queries.mutation.createMesNoFra, {name:'createMesNoFra'}),
  // graphql(queries.mutation.editMesNoFra, {name:'editMesNoFra'}),
  graphql(queries.mutation.deleteMesNoFra, {name:'deleteMesNoFra'}),

  graphql(queries.query.allUsuarios, {name:'allUsuarios1'}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(VerCli2)